let cbduJsonSample = [
    {
        "number": 1468,
        "userid": 3,
        "datestamp": "2009-07-08 21:27:25",
        "place_of_pub": "[Warszawa?]",
        "full_text_status": "public",
        "sheets": "Knlb. 2",
        "eprintid": 14680,
        "lastmod": "2009-11-09 20:19:15",
        "abstract": "DIARIUSZ SEJMU ELECTIONIS",
        "eprint_status": "archive",
        "status_changed": "2009-07-08 21:27:25",
        "dir": "disk0/00/01/46/80",
        "sources": "E. - K\u0142odz. 164",
        "metadata_visibility": "show",
        "sheet_format": "4\u00b0",
        "year": 1697,
        "documents": [
            {
                "main": "Z1468.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36147",
                        "filesize": 3515100,
                        "fileid": 36147,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0003l.pdf"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36148",
                        "filesize": 2562716,
                        "fileid": 36148,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0004.pdf"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36149",
                        "filesize": 3344829,
                        "fileid": 36149,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0003r.pdf"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36150",
                        "filesize": 415370,
                        "fileid": 36150,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0004.djvu"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36151",
                        "filesize": 706775,
                        "fileid": 36151,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0003l.djvu"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36152",
                        "filesize": 67,
                        "fileid": 36152,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "Z1468.djvu"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36153",
                        "filesize": 3446596,
                        "fileid": 36153,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36154",
                        "filesize": 12867808,
                        "fileid": 36154,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "Z1468.pdf"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36155",
                        "filesize": 688762,
                        "fileid": 36155,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0003r.djvu"
                    },
                    {
                        "objectid": 799,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/36156",
                        "filesize": 701050,
                        "fileid": 36156,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:54",
                        "filename": "0002.djvu"
                    }
                ],
                "docid": 799,
                "uri": "https://cbdu.ijp.pan.pl/id/document/799",
                "rev_number": 1,
                "security": "public",
                "eprintid": 14680,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/799"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 11216,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53506",
                        "filesize": 82636,
                        "hash_type": "MD5",
                        "fileid": 53506,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:17:27",
                        "hash": "5a69506ee231769233bd6164c58a5d0c",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 11216,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11216",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14680,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/799"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 11217,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53507",
                        "filesize": 33636,
                        "hash_type": "MD5",
                        "fileid": 53507,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:17:27",
                        "hash": "3525e0c15e4ec9934abf5973610f20b6",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 11217,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11217",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14680,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/799"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 11218,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53508",
                        "filesize": 8492,
                        "hash_type": "MD5",
                        "fileid": 53508,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:17:28",
                        "hash": "9557e42037a00bd26607925dce73dc62",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 11218,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11218",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14680,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/799"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/799"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 11219,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53509",
                        "filesize": 1943,
                        "hash_type": "MD5",
                        "fileid": 53509,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:17:28",
                        "hash": "7c94c86bb4521eb8f92f1aee0d2cb883",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 11219,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11219",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14680,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/14680",
        "full_metadata": "[Tytu\u0142 nag\u0142., ant.:] Dy\u00e1riusz Seimu Electionis pod || Warszaw\u0105 a die 15. Maij Ann1697. |]4J. Knlb. 2, sygn. A2,\r\nE. - K\u0142odz. 164.\r\nOssol. Cz-468-IlI adl.\r\nPAN K\u00f3rn. 2397 adl. 4\r\nRacz. III. O.e.31 adl.",
        "publisher": "[B. dr.]",
        "microfilms": "BN Mf. 32649",
        "sheet_signing": "Sygn. A^2^",
        "rev_number": 11,
        "historical_commentary": "Zawiera relacj\u0119 z pierwszych dni sejmu elekcyjnego 1697, przed wyborem marsza\u0142ka. Kandydatami, po wykluczeniu \"rodaka\" - czyli w praktyce Jakuba Sobieskiego, byli wy\u0142\u0105cznie pretendenci zagraniczni. Najpowa\u017cniejszym by\u0142 kandydat francuski Franciszek Ludwik ksi\u0105\u017c\u0119 Conti, na rzecz kt\u00f3rego agitowa\u0142 ambasador Polignac. Marsza\u0142kiem sejmu zosta\u0142 stronnik Francji Kazimierz Bieli\u0144ski, a trwa\u0142 on do 27 czerwca.",
        "copies": [
            "Czart. 31646 II",
            "Ossol. Cz-468-III adl.",
            "PAN K\u00f3rn. 2397 adl. 4",
            "Racz. III. O.e.31 adl."
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "full_title": "[Tytu\u0142 nag\u0142., ant.:] Dy\u00e1riusz Seimu Electionis pod || W\u00e0rsz\u00e1w\u0105 a die 15. Maij Ann 1697. ||",
        "title": "Te wyniki są zawsze takie same, bo nie mogę odpytać CBDU, przez brak nagłówku CORS"
    },
    {
        "number": 375,
        "userid": 3,
        "datestamp": "2009-07-08 21:25:21",
        "place_of_pub": "[B. m. dr.]",
        "full_text_status": "public",
        "sheets": "Knlb. 6",
        "eprintid": 3750,
        "lastmod": "2009-11-12 19:53:31",
        "abstract": "Sprostowanie wiadomo\u015bci o zamierzonej koronacji kr\u00f3lewicza Jana Kazimierza oraz o zawarciu przez Zygmunta III uk\u0142adu z kr\u00f3lem szwedzkim Gustawem Adolfem. Zawiera: \u201eDo Czytelnika.\u201d. Tekst. ",
        "eprint_status": "archive",
        "status_changed": "2009-07-08 21:25:21",
        "dir": "disk0/00/00/37/50",
        "sources": "E. XXIII 257. GK. 496. K\u0142odz. 74",
        "metadata_visibility": "show",
        "sheet_format": "4\u00b0",
        "short_title": "Odpis albo wiadomo\u015b\u0107 pewna o opacznym nowin p\u0142onnych udaniu",
        "year": 1627,
        "documents": [
            {
                "main": "Z375.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11821",
                        "filesize": 5380328,
                        "fileid": 11821,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0005r.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11822",
                        "filesize": 4494251,
                        "fileid": 11822,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0007l.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11823",
                        "filesize": 4526404,
                        "fileid": 11823,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0003r.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11824",
                        "filesize": 408572,
                        "fileid": 11824,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0002.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11825",
                        "filesize": 5268666,
                        "fileid": 11825,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0004r.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11826",
                        "filesize": 5271229,
                        "fileid": 11826,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11827",
                        "filesize": 5004867,
                        "fileid": 11827,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0008.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11828",
                        "filesize": 4982555,
                        "fileid": 11828,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0005l.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11829",
                        "filesize": 4582816,
                        "fileid": 11829,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0007r.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11830",
                        "filesize": 56437638,
                        "fileid": 11830,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "Z375.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11831",
                        "filesize": 335400,
                        "fileid": 11831,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0007r.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11832",
                        "filesize": 115537,
                        "fileid": 11832,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0003l.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11833",
                        "filesize": 357734,
                        "fileid": 11833,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0006r.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11834",
                        "filesize": 399482,
                        "fileid": 11834,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0005r.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11835",
                        "filesize": 285054,
                        "fileid": 11835,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0006l.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11836",
                        "filesize": 4517849,
                        "fileid": 11836,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0006r.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11837",
                        "filesize": 4758480,
                        "fileid": 11837,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0006l.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11838",
                        "filesize": 296276,
                        "fileid": 11838,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0003r.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11839",
                        "filesize": 320697,
                        "fileid": 11839,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0008.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11840",
                        "filesize": 290577,
                        "fileid": 11840,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0007l.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11841",
                        "filesize": 330902,
                        "fileid": 11841,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0004l.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11842",
                        "filesize": 107,
                        "fileid": 11842,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "Z375.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11843",
                        "filesize": 308964,
                        "fileid": 11843,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0005l.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11844",
                        "filesize": 2688604,
                        "fileid": 11844,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0003l.pdf"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11845",
                        "filesize": 400101,
                        "fileid": 11845,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0004r.djvu"
                    },
                    {
                        "objectid": 879,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11846",
                        "filesize": 4966835,
                        "fileid": 11846,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:30",
                        "filename": "0004l.pdf"
                    }
                ],
                "docid": 879,
                "uri": "https://cbdu.ijp.pan.pl/id/document/879",
                "rev_number": 1,
                "security": "public",
                "eprintid": 3750,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/879"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 11533,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53825",
                        "filesize": 58731,
                        "hash_type": "MD5",
                        "fileid": 53825,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:24:49",
                        "hash": "559d4c6d499daa9193e0696ace33abaf",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 11533,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11533",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3750,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/879"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 11534,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53826",
                        "filesize": 24043,
                        "hash_type": "MD5",
                        "fileid": 53826,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:24:51",
                        "hash": "0fa0474e4ea19754e08511b46f7e8d7c",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 11534,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11534",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3750,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/879"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 11535,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53827",
                        "filesize": 7158,
                        "hash_type": "MD5",
                        "fileid": 53827,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:24:52",
                        "hash": "50ce735e6b25def20619d3daabad80de",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 11535,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11535",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3750,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/879"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/879"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 11536,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/53828",
                        "filesize": 1970,
                        "hash_type": "MD5",
                        "fileid": 53828,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:24:53",
                        "hash": "cdacf866f1dedc0a01db9f0682f46f6d",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 11536,
                "uri": "https://cbdu.ijp.pan.pl/id/document/11536",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3750,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/3750",
        "full_metadata": "Odpis albo wiadomo\u015b\u0107 pewna o opacznym nowin p\u0142onnych udaniu. [B- m. dr.] 1627.4\u00b0. Knlb. 6, sygn. A* B2. -,\r\nE. XXIII 257. GK. 496. K\u0142odz. 74.\r\n[Tytu\u0142, ant.:] ODPIS || [frakt.:] \u00e1bo II Wiadomo\u015b\u0107 pewna n\u00e1 opaczne nowin || p\u0142onnych vd\u00e1-nie. Roku 1627. ||\r\nZawiera: \u201eDo Czytelnika.\u201d'. Tekst.\r\nSprostowanie wiadomo\u015bci o zamierzonej koronacji kr\u00f3lewicza Jana Kazimierza oraz o zawarciu przez Zygmunta III\r\nuk\u0142adu z kr\u00f3lem szwedzkim Gustawem Adolfem,\r\nBUW 28. 20. 3. 1092 Czart. 6191 I Ossol. XVII-207O-III\r\nPAN Gd. NI 7 8' adl. 12; 613/55 adl. 22\r\nPAN K\u00f3rn. 13233 def.: brak k. Bi",
        "latin_dictionary": [
            {
                "explanation": "Liwiusz: skazy na wiarygodno\u015bci s\u0105 wi\u0119ksze ni\u017c mo\u017cna w og\u00f3le s\u0105dzi\u0107. [cf. Liwiusz 3.73]",
                "entry": "Liuius: Fidei damna maiora sunt omni aestimatione."
            },
            {
                "explanation": "z pojednania / porozumienia",
                "entry": "ex condictamine"
            },
            {
                "explanation": "wolna elekcja (wyb\u00f3r) w\u0142adcy",
                "entry": "libera Principis electio"
            },
            {
                "explanation": "jawnie",
                "entry": "in publico"
            },
            {
                "explanation": "w autorach i propagatorach plotki",
                "entry": "in authoribs et promotoribus fabulae"
            },
            {
                "explanation": "kochaj\u0105cy wiedz\u0119",
                "entry": "eruditionis amantes"
            },
            {
                "explanation": "\u017cartobliwie do wzbudzenia gorliwo\u015bci (?)",
                "entry": "ludicre ad excitandum studii alacritatem"
            },
            {
                "explanation": "O rzeczach wielkich nale\u017cy s\u0105dzi\u0107 z wielk\u0105 rozwag\u0105 (?) [Seneka M\u0142odszy, Listy moralne do Lucyliusza 71.24.1]",
                "entry": "Magno animo de rebus magnis iudicandum est."
            },
            {
                "explanation": "Nieszcz\u0119sny, kto gardzi w\u0142asnym \u015bwiadectwem.",
                "entry": "Miser qui se testem contemnit."
            },
            {
                "explanation": "U (cz\u0142owieka) zazdrosnego oczy si\u0119 zapadaj\u0105, umys\u0142 / dusza / my\u015bl si\u0119 rozpala, w my\u015bleniu pojawia si\u0119 szale\u0144stwo, zgrzytaj\u0105 z\u0119by. [Gregorius Magnus, Moralia in Iob 5.46]",
                "entry": "Inuidi oculi deprimuntur, mens accenditur, fit in cogitatione rabies, in dentibus stridor."
            },
            {
                "explanation": "W my\u015blach nawet swoich nie z\u0142orzecz kr\u00f3lowi. [Ks. Koheleta 10]",
                "entry": "In cogitatione tua Regi ne detrahas"
            },
            {
                "explanation": "bo ptaki powietrzne zanios\u0105 g\u0142os tw\u00f3j, a to, co skrzydlate, doniesie s\u0142owa [Ks. Koheleta 10]",
                "entry": "quia et aves caeli portabunt vocem tuam et qui habet pennas annunciabit sententiam"
            },
            {
                "explanation": "zanios\u0105 g\u0142os tw\u00f3j",
                "entry": "portabunt vocem tuam"
            },
            {
                "explanation": "a to, co skrzydlate",
                "entry": "qui habet pennas"
            },
            {
                "explanation": "plebejusz",
                "entry": "plebeius"
            },
            {
                "explanation": "Nie powinien by\u0107 w\u0142adc\u0105 jednocze\u015bnie starszy i m\u0142odszy brat.",
                "entry": "Non debet simul Principem agere maior et minor frater."
            },
            {
                "explanation": "Kr\u00f3l w\u0142ada poddanymi, jak rodzice dzie\u0107mi.",
                "entry": "Rex subditis imperat, ut parentes filiis."
            },
            {
                "explanation": "G\u0142upcem mi si\u0119 zdaje ten, kto uzna, \u017ce mo\u017ce zawrze\u0107 pewn\u0105 i sta\u0142\u0105 przyja\u017a\u0144 z kim\u015b, kto utraci\u0142 przyja\u017a\u0144 bratersk\u0105. [Platon]",
                "entry": "Insaniae mihi videtur, qui sibi firmam constantemque amicitiam cum eo fore persuasum habebit, qui fraternam perdiderit."
            },
            {
                "explanation": "na niesprawiedliwych warunkach",
                "entry": "iniquis condicionibus"
            },
            {
                "explanation": "Kr\u00f3lewsk\u0105 jest rzecz\u0105, \u017ce jeste\u015b krytykowany, chocia\u017c dobrze post\u0105pi\u0142e\u015b.",
                "entry": "Regium est, cum bene feceris, male audire."
            },
            {
                "explanation": "ksi\u0105\u017c\u0119",
                "entry": "Comes"
            },
            {
                "explanation": "Na wojnie nie nale\u017cy dwukrotnie pope\u0142nia\u0107 (tego samego) b\u0142\u0119du.",
                "entry": "Non est in bello bis errare."
            },
            {
                "explanation": "Eurypidesa",
                "entry": "Euripidis"
            },
            {
                "explanation": "Mars (=wojna) najbardziej nienawidzi oci\u0105gania si\u0119 (zw\u0142oki).",
                "entry": "Maxime Mars odit cinctantem."
            },
            {
                "explanation": "z zachowaniem prawa ... dziedziczenia",
                "entry": "salvo iure ... haereditario"
            },
            {
                "explanation": "tch\u00f3rzostwo / zw\u0105tpienie",
                "entry": "ignavia"
            },
            {
                "explanation": "Za niesprawiedliw\u0105 nale\u017cy uzna\u0107 walk\u0119, w kt\u00f3rej cz\u0142owiek prywatny mo\u017ce by\u0107 zwyci\u0119zc\u0105, a kr\u00f3l pokonanym.",
                "entry": "Iniquum certamen esse oportet, in quo victorem privatum esse licet, victum regem."
            },
            {
                "explanation": "b\u0142\u0105d / nieszcz\u0119\u015bcie wojny",
                "entry": "error belli"
            },
            {
                "explanation": "cesarz Juliusz",
                "entry": "Caesar Iulius"
            },
            {
                "explanation": "To jest jedyny (dobry) moment na zawarcie pokoju, kiedy ka\u017cda ze stron ufa sobie i obie wydaj\u0105 si\u0119 r\u00f3wne. [Cezar, pami\u0119tniki o wojnie domowej 3.10.7.1] ",
                "entry": "Hoc unum est tempus de pace agendi, dum sibi uterque confidit et pares ambo videntur."
            }
        ],
        "microfilms": "BN Mf. 27374",
        "sheet_signing": "Sygn. A^4^ B^2^",
        "rev_number": 21,
        "copies": [
            "BN XVII. 3. 3393",
            "BUW 28. 20. 3. 1092 ",
            "Czart. 6191 I ",
            "Ossol. XVII-207O-III",
            "PAN Gd. Nl 7 8\u00b0 adl. 12; 613/55 adl. 22",
            "PAN K\u00f3rn. 13233 def.: brak k. B,,1,,"
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "full_title": "[Tytu\u0142, ant.:] ODPIS || [frakt.:] \u00e1bo || Wi\u00e1domo\u015b\u0107 pewna n\u00e1 opaczne nowin || p\u0142onnych vd\u00e1nie. Roku 1627. ||",
        "date_of_pub": 1627,
        "title": "Odpis albo wiadomo\u015b\u0107 pewna o opacznym nowin p\u0142onnych udaniu"
    },
    {
        "number": 1540,
        "userid": 3,
        "datestamp": "2009-07-08 21:27:59",
        "place_of_pub": "Krak\u00f3w",
        "full_text_status": "public",
        "sheets": "K. 1",
        "eprintid": 15400,
        "lastmod": "2009-12-29 16:09:30",
        "eprint_status": "archive",
        "status_changed": "2009-07-08 21:27:59",
        "dir": "disk0/00/01/54/00",
        "sources": "E. - GK. 575. K\u0142odz. 197",
        "metadata_visibility": "show",
        "sheet_format": "2\u00b0",
        "year": 1700,
        "documents": [
            {
                "main": "Z1540.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 1389,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37337",
                        "filesize": 1120889,
                        "fileid": 37337,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:07",
                        "filename": "0473.djvu"
                    },
                    {
                        "objectid": 1389,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37338",
                        "filesize": 55,
                        "fileid": 37338,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:07",
                        "filename": "Z1540.djvu"
                    },
                    {
                        "objectid": 1389,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37339",
                        "filesize": 12873697,
                        "fileid": 37339,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:07",
                        "filename": "0473.pdf"
                    },
                    {
                        "objectid": 1389,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37340",
                        "filesize": 10962462,
                        "fileid": 37340,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:07",
                        "filename": "0472.pdf"
                    },
                    {
                        "objectid": 1389,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37341",
                        "filesize": 23835680,
                        "fileid": 37341,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:07",
                        "filename": "Z1540.pdf"
                    },
                    {
                        "objectid": 1389,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37342",
                        "filesize": 747077,
                        "fileid": 37342,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:07",
                        "filename": "0472.djvu"
                    }
                ],
                "docid": 1389,
                "uri": "https://cbdu.ijp.pan.pl/id/document/1389",
                "rev_number": 1,
                "security": "public",
                "eprintid": 15400,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/1389"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 13535,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55833",
                        "filesize": 65004,
                        "hash_type": "MD5",
                        "fileid": 55833,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:57:12",
                        "hash": "f84d72ad3a56459e6d8957910c0f5e02",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 13535,
                "uri": "https://cbdu.ijp.pan.pl/id/document/13535",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15400,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/1389"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 13536,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55834",
                        "filesize": 24768,
                        "hash_type": "MD5",
                        "fileid": 55834,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:57:13",
                        "hash": "034b38f6cbe0b5487e969fb00ff4db58",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 13536,
                "uri": "https://cbdu.ijp.pan.pl/id/document/13536",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15400,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/1389"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 13537,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55835",
                        "filesize": 6295,
                        "hash_type": "MD5",
                        "fileid": 55835,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:57:14",
                        "hash": "4a113b85dc7b71dc4e1c2406ac4d82d0",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 13537,
                "uri": "https://cbdu.ijp.pan.pl/id/document/13537",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15400,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1389"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/1389"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 13538,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55836",
                        "filesize": 1705,
                        "hash_type": "MD5",
                        "fileid": 55836,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:57:15",
                        "hash": "0aca1b16711c2ee7882bd218fde0c26f",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 13538,
                "uri": "https://cbdu.ijp.pan.pl/id/document/13538",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15400,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/15400",
        "full_metadata": "[Tytu\u0142 nag\u0142., ant.:] RELACYA || E\u0142ekcyi Oyca S. Klemensa [kurs.:] XI. 23. 9bris [ant.:}: 1700. odprawioney; y Wiadomo\u015bci || ro\u017cne Cudzoziemskie 25. [kurs.:] Decembris [ant.:] w Krak:wydane 1700. i, 2\\ K. 1.\r\nE. - GK. 575. K\u0142odz. 197.",
        "publisher": "[B. dr.]",
        "microfilms": "BN Mf. 30419",
        "rev_number": 7,
        "historical_commentary": "Relacja z elekcji Klemensa XI utrzymana w tonie podnio\u015ble-bogobojnym. W istocie elekt - Giovanni Francesco Barberini (1649-1721, kardyna\u0142 od 1690) - uwa\u017cany by\u0142 za kompromisowego wobec ostro si\u0119 zwalczaj\u0105cych frakcji francuskiej i austriackiej, a mimo to zwleka\u0142 trzy dni z przyj\u0119ciem wyboru. Jego uroczysty ingres do Bazyliki Latera\u0144skiej odby\u0142 si\u0119 dopiero w kwietniu nast\u0119pnego roku. Ponadto relacja zawiera wiadomo\u015bci o uroczysto\u015bciach pogrzebowych po \u015bmierci kr\u00f3la Hiszpanii Karola II (zm. 1 XI 1700) oraz zapowiedzi konfliktu o sukcesj\u0119 po nim, kt\u00f3ry mia\u0142 si\u0119 rozwin\u0105\u0107 w tzw. wojn\u0119 o sukcesj\u0119 hiszpa\u0144sk\u0105. Wzmiankowany w tek\u015bcie ksi\u0105\u017c\u0119 Anjou, uczyniony przez Karola nast\u0119pc\u0105 w testamencie sporz\u0105dzonym na miesi\u0105c przed \u015bmierci\u0105, to p\u00f3\u017aniejszy kr\u00f3l Filip V; natomiast traktat, kt\u00f3ry kwesti\u0119 sukcesji regulowa\u0142 inaczej - oddaj\u0105c tron J\u00f3zefowi Ferdynandowi bawarskiemu, zmar\u0142emu przedwcze\u015bnie w 1699 - podpisano w Hadze w 1698, bez zgody ani wiedzy Hiszpan\u00f3w.",
        "copies": [
            "Ossol. Cz-1540-IV ",
            "PAN K\u00f3rn. 3343"
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "full_title": "[Tytu\u0142 nag\u0142., ant.:] RELACYA || Elekcyi Oyc\u00e1 S. Klemens\u00e1 [kurs.:] XI. 23. 9bris [ant.:] 1700. odprawioney; y Wi\u00e1domo\u015b\u0107i || ro\u017cne Cudzo\u017aiemskie 25. [kurs.:] Decembris [ant.:] w Kr\u00e1k: wydane 1700. ||",
        "title": "RELACYA Elekcyi Oyc\u00e1 S. Klemens\u00e1 XI. 23. 9bris 1700. odprawioney; y Wi\u00e1domo\u015b\u0107i ro\u017cne Cudzo\u017aiemskie 25. Decembris w Kr\u00e1k: wydane 1700. "
    },
    {
        "userid": 3,
        "datestamp": "2009-07-08 21:25:20",
        "place_of_pub": "Lw\u00f3w",
        "full_text_status": "public",
        "eprintid": 3700,
        "abstract": "Relacja rymowana. Zawiera: \u201eDo Czytelnik\u00e1.\u201d. Dedykacja autora dla Tomasza Zamoyskiego, wojewody kijowskiego. Tekst \u201eZoilus.\u201d",
        "status_changed": "2009-07-08 21:25:20",
        "sheet_format": "4\u00b0",
        "short_title": "Relacja prawdziwa pogromu poga\u0144stwa pod Bia\u0142\u0105 Cerkwi\u0105 7 pa\u017adziernika 1626 przez Stefana Chmieleckiego",
        "author": "Dobrocieski Jan",
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/3700",
        "full_metadata": "WG: Korekta tytu\u0142\u00f3w - ok. Przenios\u0142em te\u017c nazwisko autora do pola \"Autor\" z \"Tytu\u0142u kr\u00f3tkiego\".\r\n\r\nDobrocieski Jan: Relacja prawdziwa pogromu poga\u0144stwa pod Bia\u0142\u0105 Cerkwi\u0105 7 pa\u017adzier-nika 1626 przez Stefana\r\nChmieleckiego. Lw\u00f3w, Jan Szeliga [po 7 X 1626]. 4\u00b0. Knlb. 8, sygn. A-B4.\r\nE. -\r\n[Tytu\u0142 w podw\u00f3jnej ramce linijnej, ant.:] Rel\u00e1cya Prawdziwa || POGROMV POGAN- II STWA POD BIA\u0141\u0104 CERKWI\u0104 |\r\nRoku 1626. dni\u00e1 7. Octobra szcz\u0119\u015bliwie || otrzymanego. || PREZ IEGO MO\u015aCI li PANA STEPHANA CHMIELECKIEGO,\r\nCHOR\u0104- || zego Woiewodztwa Braclawskie-go, kto- If rego Pog\u00e1nslw\u00e1 z Mur\u00e1dyn, So\u0142tanem, w liczbie || by\u0142o\r\nO\u015bmd\u017ciesiat tysi\u0119cy. || [kurs.:] Naywyz\u00dfemu P\u00e1nu niechay b\u0119dzie cze\u015b\u0107 i! y chwa\u0142a, \u00e1 to II [ant.:] PRZEZ [11ANA\r\nDOBROCIE-SKIEGO miedzy II ludzie podana, i [linia] i WE LWOWIE, | W Drukarni lan\u00e1 Szeligi I. M. X. ARCYBISKVPA ||\r\nLwowskiego Drukarza. ||\r\nZawiera: \u201eDo Czytelnika.\u201d. Dedykacja aulora dla Tomasza Zamoyskiego, wojewody kijowskiego. Tekst, \u201eZoilus.\u201dRelacja\r\nrymowana. . -",
        "publisher": "Jan Szeliga",
        "sheet_signing": "Sygn. A-B^4^",
        "rev_number": 24,
        "dictionary": [
            {
                "explanation": "zaj\u0119cie, praca",
                "entry": "zabawa"
            },
            {
                "explanation": "wojna",
                "entry": "Marsa i Bellony dzie\u0142o"
            },
            {
                "explanation": "bogini wojny",
                "entry": "Bellona "
            },
            {
                "explanation": "do, ku",
                "entry": "przeciwko"
            },
            {
                "explanation": "niewygody, trudy",
                "entry": "niewczasy"
            },
            {
                "explanation": "albo",
                "entry": "abo"
            },
            {
                "explanation": "sposobami",
                "entry": "sposoby "
            },
            {
                "explanation": "zaczerpni\u0119ty",
                "entry": "wyczerpniony"
            },
            {
                "explanation": "\u0142atwiej",
                "entry": "snadniej"
            },
            {
                "explanation": "pochwa\u0142a, uznanie",
                "entry": "zalecenie"
            },
            {
                "explanation": "zaradno\u015b\u0107, staranie ko\u0142o czego, pieczo\u0142owito\u015b\u0107",
                "entry": "przemys\u0142"
            },
            {
                "explanation": "przen. obrona, os\u0142ona",
                "entry": "zas\u0142ona"
            },
            {
                "explanation": "pospiesza\u0107 do czego",
                "entry": "przyspiesza\u0107 do czego"
            },
            {
                "explanation": "odgranicza\u0107, oddziela\u0107, utrzymywa\u0107 co w odpowiednich granicach",
                "entry": "miarkowa\u0107"
            },
            {
                "explanation": "bra\u0107 w raz z innymi udzia\u0142 w sprowadzaniu (tu: wojska)",
                "entry": "sp\u00f3\u0142zwodzi\u0107"
            },
            {
                "explanation": "turecki",
                "entry": "bisurma\u0144ski"
            },
            {
                "explanation": "ob\u00f3z wojskowy turecki lub tatarski",
                "entry": "kosz"
            },
            {
                "explanation": "oddzia\u0142 wojska zapuszczaj\u0105cy si\u0119 w kraj nieprzyjaciela",
                "entry": "zagon"
            },
            {
                "explanation": "ochotnik",
                "entry": "ochoczy"
            },
            {
                "explanation": "budz\u0105cy zapa\u0142",
                "entry": "\u017carliwy"
            },
            {
                "explanation": "naprawd\u0119, rzeczywi\u015bcie",
                "entry": "prawie"
            },
            {
                "explanation": "wyg\u0142osi\u0107 mow\u0119",
                "entry": "uczyni\u0107 rzecz"
            },
            {
                "explanation": "wyprawa oddzia\u0142u wojska na rozpoznanie lub w celu stoczenia walki z mniejszymi si\u0142ami wroga",
                "entry": "podjazd"
            },
            {
                "explanation": "robot\u0119 ... ko\u0144czyli",
                "entry": "robot\u0119 .... konali"
            },
            {
                "explanation": "niezmiennie",
                "entry": "jednostajnie"
            },
            {
                "explanation": "szybko przeby\u0107 jak\u0105\u015b drog\u0119",
                "entry": "ubiec"
            },
            {
                "explanation": "jednym ci\u0105giem, tu o \u017co\u0142nierzach: jeden za drugim, po kolei",
                "entry": "jednym cugiem"
            },
            {
                "explanation": "tu: do pewnego stopnia podporz\u0105dkowa\u0142 si\u0119 innym dow\u00f3dcom w celu skutecznego wsp\u00f3\u0142dzia\u0142ania",
                "entry": "troch\u0119 uleg\u0142"
            },
            {
                "explanation": "przebrany, tj. wybrany jako najlepszy",
                "entry": "przeborny"
            },
            {
                "explanation": "zbiorowo: ci\u0119\u017cka bro\u0144 palna, dzia\u0142a",
                "entry": "armata"
            },
            {
                "explanation": "zatrzyma\u0107 si\u0119, tu: w celu za\u0142o\u017cenia obozu wojskowego",
                "entry": "postawi\u0107 si\u0119"
            },
            {
                "explanation": "oddzia\u0142 wojska wys\u0142any na zwiady, podjazd",
                "entry": "czata"
            },
            {
                "explanation": "zdanie",
                "entry": "wzdanie"
            },
            {
                "explanation": "jeniec schwytany dla uzyskania wiadomo\u015bci o sytuacji w obozie wroga",
                "entry": "j\u0119zyk"
            },
            {
                "explanation": "chwalebnie",
                "entry": "s\u0142awnie"
            },
            {
                "explanation": "czujny",
                "entry": "czu\u0142y"
            },
            {
                "explanation": "machina wojenna, wie\u017ca, taran",
                "entry": "czyn"
            },
            {
                "explanation": "opodal",
                "entry": "podal"
            },
            {
                "explanation": "szczep tatarski pod wodz\u0105 chana; zbiorowo: wojsko tatarskie",
                "entry": "orda"
            },
            {
                "explanation": "fortele",
                "entry": "fortyle"
            },
            {
                "explanation": "mie\u0107 do czynienia z kim",
                "entry": "kosztowa\u0107 si\u0119 z kim"
            },
            {
                "explanation": "spotkanie, tu: starcie, bitwa",
                "entry": "potkanie"
            },
            {
                "explanation": "sta\u0107 w porz\u0105dku, w szyku",
                "entry": "w sprawie sta\u0107"
            },
            {
                "explanation": "potr\u00f3jne",
                "entry": "troje"
            },
            {
                "explanation": "Turek",
                "entry": "bisurmanin"
            },
            {
                "explanation": "tylko, por. jeno",
                "entry": "jedno"
            },
            {
                "explanation": "\u017co\u0142nierz s\u0142u\u017c\u0105cy w wojsku kwarcianym, tj. wojsku zaci\u0119\u017cnym, utrzymywanym z podatku zwanego kwart\u0105",
                "entry": "kwarciany"
            },
            {
                "explanation": "b\u0119d\u0105c pe\u0142nym ochoty, pragnienia",
                "entry": "chciwie"
            },
            {
                "explanation": "pobudzony, rozpalony (tu: \u017c\u0105dz\u0105 walki); rozjuszony",
                "entry": "zajuszony"
            },
            {
                "explanation": "stoczona ... bitwa",
                "entry": "zwiedziona ... bitwa"
            },
            {
                "explanation": "tu: zwlekanie, oci\u0105ganie si\u0119, marudzenie",
                "entry": "zabawa"
            },
            {
                "explanation": "przodem",
                "entry": "przodkiem"
            },
            {
                "explanation": "spotka\u0107 si\u0119, tj. stoczy\u0107 bitw\u0119",
                "entry": "potka\u0107 si\u0119"
            },
            {
                "explanation": "przede wszystkim, g\u0142\u00f3wnie, zw\u0142aszcza",
                "entry": "osobliwie"
            },
            {
                "explanation": "w posi\u0142ku, tj. jako wsparcie, pomoc",
                "entry": "w posie\u0142ku"
            },
            {
                "explanation": "potka\u0107 si\u0119, tj. wzi\u0105\u0107 udzia\u0142 w bitwie",
                "entry": "podka\u0107 si\u0119"
            },
            {
                "explanation": "stracili ochot\u0119 do walki, nadziej\u0119 na zwyci\u0119stwo",
                "entry": "im serca upad\u0142y"
            },
            {
                "explanation": "hufce posi\u0142kowe, tj. wspieraj\u0105ce formacje taktyczne, poczty \u017co\u0142nierzy",
                "entry": "ufy posilne"
            },
            {
                "explanation": "oto",
                "entry": "owo"
            },
            {
                "explanation": "\u015bredni, tj. \u015brodkowy",
                "entry": "\u015brzedni"
            },
            {
                "explanation": "hufiec, tj. formacja taktyczna, poczet \u017co\u0142nierzy",
                "entry": "uff"
            },
            {
                "explanation": "wielki",
                "entry": "walny"
            },
            {
                "explanation": "zamkn\u0105\u0107 oko (oczy), tj. zasn\u0105\u0107, tu o s\u0142o\u0144cu: zaj\u015b\u0107",
                "entry": "zamru\u017cy\u0107 okiem"
            },
            {
                "explanation": "ledwie",
                "entry": "w male"
            },
            {
                "explanation": "inny",
                "entry": "inszy"
            },
            {
                "explanation": "kl\u0119ska",
                "entry": "zniesienie"
            },
            {
                "explanation": "kosz, tj. wojskowy ob\u00f3z tatarski",
                "entry": "koszysko"
            },
            {
                "explanation": "\u0142upy, zdobycze",
                "entry": "plony"
            },
            {
                "explanation": "opuszczony, porzucony, pozostawiony na skutek ucieczki",
                "entry": "odbie\u017cany"
            },
            {
                "explanation": "rasa konia",
                "entry": "kazan"
            },
            {
                "explanation": "konie",
                "entry": "kony"
            },
            {
                "explanation": "bitwa, walka",
                "entry": "potrzeba"
            },
            {
                "explanation": "dokona\u0107 przegl\u0105du",
                "entry": "spatrzy\u0107 "
            },
            {
                "explanation": "pilnie strzeg\u0142",
                "entry": "przestrzega\u0142 srodze"
            },
            {
                "explanation": "oddzia\u0142 wojska; chor\u0105giew",
                "entry": "znak"
            },
            {
                "explanation": "ulec z\u0142udnemu poczuciu bezpiecze\u0144stwa, nie umie\u0107 dostrzec zagro\u017cenia",
                "entry": "ubezpieczy\u0107"
            },
            {
                "explanation": "wtem, szybko",
                "entry": "w tym"
            },
            {
                "explanation": "prosto przed siebie; na prze\u0142aj",
                "entry": "naprzeszczwa\u0142"
            },
            {
                "explanation": "zagarn\u0105\u0107",
                "entry": "zarwa\u0107"
            },
            {
                "explanation": null,
                "entry": "baterbi"
            },
            {
                "explanation": "omin\u0105\u0107",
                "entry": "uchyli\u0107"
            },
            {
                "explanation": "rado\u015b\u0107, weso\u0142a uczta, zabawa",
                "entry": "wesele"
            },
            {
                "explanation": "przestrzegaj\u0105cy zasad sztuki wojennej",
                "entry": "wojen prawy"
            },
            {
                "explanation": "sprawa, rzecz przygotowana ca\u0142kowicie, uko\u0144czona",
                "entry": "gotowe"
            },
            {
                "explanation": "atakowa\u0142 na pewniaka, po uprzednim dok\u0142adnym przygotowaniu uderzenia",
                "entry": "w gotowe uderza\u0142"
            },
            {
                "explanation": "zbili",
                "entry": "zbieli"
            },
            {
                "explanation": "sprzyja\u0107 komu; przewodzi\u0107 komu",
                "entry": "kredencowa\u0107 komu"
            },
            {
                "explanation": "wdzi\u0119czno\u015b\u0107",
                "entry": "dank"
            },
            {
                "explanation": "hardo",
                "entry": "hardzie"
            },
            {
                "explanation": "dzielnie, odwa\u017cnie, \u015bmia\u0142o",
                "entry": "przewa\u017cnie"
            },
            {
                "explanation": "bardzo, z ca\u0142ego serca",
                "entry": "serdecznie"
            },
            {
                "explanation": "a tak\u017ce, r\u00f3wnie\u017c",
                "entry": "wt\u0105\u017c"
            },
            {
                "explanation": "mo\u017ce, a nu\u017c; a niech\u017ce",
                "entry": "aza"
            },
            {
                "explanation": "w\u00f3dz, ksi\u0105\u017c\u0119, szlachcic tatarski",
                "entry": "murza"
            }
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "number": 370,
        "sheets": "Knlb. 8",
        "lastmod": "2010-01-07 12:38:44",
        "eprint_status": "archive",
        "dir": "disk0/00/00/37/00",
        "metadata_visibility": "show",
        "sources": "E. -",
        "year": 1626,
        "documents": [
            {
                "main": "Z370.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11661",
                        "filesize": 5197353,
                        "fileid": 11661,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0005r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11662",
                        "filesize": 4825564,
                        "fileid": 11662,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0005l.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11663",
                        "filesize": 4036563,
                        "fileid": 11663,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0010.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11664",
                        "filesize": 3305914,
                        "fileid": 11664,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0003r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11665",
                        "filesize": 125,
                        "fileid": 11665,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "Z370.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11666",
                        "filesize": 259546,
                        "fileid": 11666,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0003l.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11667",
                        "filesize": 4567941,
                        "fileid": 11667,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0004r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11668",
                        "filesize": 204451,
                        "fileid": 11668,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0007l.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11669",
                        "filesize": 209796,
                        "fileid": 11669,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0008l.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11670",
                        "filesize": 69308101,
                        "fileid": 11670,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "Z370.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11671",
                        "filesize": 4330845,
                        "fileid": 11671,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11672",
                        "filesize": 4687465,
                        "fileid": 11672,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0007r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11673",
                        "filesize": 4771100,
                        "fileid": 11673,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0008l.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11674",
                        "filesize": 4617058,
                        "fileid": 11674,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0009r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11675",
                        "filesize": 4761164,
                        "fileid": 11675,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0006r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11676",
                        "filesize": 177228,
                        "fileid": 11676,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0010.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11677",
                        "filesize": 199629,
                        "fileid": 11677,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0002.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11678",
                        "filesize": 4590681,
                        "fileid": 11678,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0007l.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11679",
                        "filesize": 223266,
                        "fileid": 11679,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0009r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11680",
                        "filesize": 4709667,
                        "fileid": 11680,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0009l.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11681",
                        "filesize": 259601,
                        "fileid": 11681,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0005r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11682",
                        "filesize": 228126,
                        "fileid": 11682,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0008r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11683",
                        "filesize": 213074,
                        "fileid": 11683,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0004r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11684",
                        "filesize": 199377,
                        "fileid": 11684,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0009l.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11685",
                        "filesize": 5208962,
                        "fileid": 11685,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0003l.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11686",
                        "filesize": 220583,
                        "fileid": 11686,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0005l.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11687",
                        "filesize": 223509,
                        "fileid": 11687,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0006r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11688",
                        "filesize": 230558,
                        "fileid": 11688,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0007r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11689",
                        "filesize": 4801967,
                        "fileid": 11689,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0008r.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11690",
                        "filesize": 4902528,
                        "fileid": 11690,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0006l.pdf"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11691",
                        "filesize": 144681,
                        "fileid": 11691,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0003r.djvu"
                    },
                    {
                        "objectid": 213,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/11692",
                        "filesize": 235357,
                        "fileid": 11692,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:29",
                        "filename": "0006l.djvu"
                    }
                ],
                "docid": 213,
                "uri": "https://cbdu.ijp.pan.pl/id/document/213",
                "rev_number": 1,
                "security": "public",
                "eprintid": 3700,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/213"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 8892,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51182",
                        "filesize": 54180,
                        "hash_type": "MD5",
                        "fileid": 51182,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:37:47",
                        "hash": "06d7ada6340808ca5c4695f930c64876",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 8892,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8892",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3700,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/213"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 8893,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51183",
                        "filesize": 25684,
                        "hash_type": "MD5",
                        "fileid": 51183,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:37:49",
                        "hash": "977fe6fc81f0a114311ece84525096f0",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 8893,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8893",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3700,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/213"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 8894,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51184",
                        "filesize": 7652,
                        "hash_type": "MD5",
                        "fileid": 51184,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:37:50",
                        "hash": "6c06105f14b6e788fdd06a98a8d04bd7",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 8894,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8894",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3700,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/213"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/213"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 8895,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51185",
                        "filesize": 1857,
                        "hash_type": "MD5",
                        "fileid": 51185,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:37:52",
                        "hash": "172d5ec16a97a46ef961449f404cec06",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 8895,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8895",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 3700,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "microfilms": "BN Mf. 5950",
        "copies": [
            "PAN Gd. Nl 3382 8\u00b0 adl. 5"
        ],
        "full_title": "[Tytu\u0142 w podw\u00f3jnej ramce linijnej, ant.:] Rel\u00e1cya Prawdziwa || POGROMV POGAN- || STWA POD BIA\u0141\u0104 CERKWI\u0104 || Roku 1626. dni\u00e1 7. Octobra szcz\u0119\u015bliwie || otrzym\u00e1nego. || PREZ IEGO MOSCI || PANA STEPHANA || CHMIELECKIEGO, CHOR\u0104- || zego Woiewodztwa Brac\u0142awskiego, kto- || rego Pog\u00e1nstw\u00e1 z Mur\u00e1dyn, So\u0142tanem, w liczbie || by\u0142o O\u015bmd\u017aie\u015bi\u0105t ty\u015bi\u0119cy. || [kurs.:] Naywy\u017c\u00dfemu P\u00e1nu niechay b\u0119d\u017aie cze\u015b\u0107 || y chwa\u0142\u00e1, \u00e1 to || [ant.:] PRZEZ || IANA DOBROCIESKIEGO miedzy || ludzie pod\u00e1na. || [linia] || WE LWOWIE, || W Druk\u00e1rni Ian\u00e1 Szeligi I. M. X. ARCYBISKVPA || Lwowskiego Drukarz\u00e1. ",
        "date_of_pub": "[po 7 X 1626]",
        "title": "Relacja prawdziwa pogromu poga\u0144stwa pod Bia\u0142\u0105 Cerkwi\u0105 7 pa\u017adziernika 1626 przez Stefana Chmieleckiego"
    },
    {
        "userid": 3,
        "connections": "# Por. poz. [[1217]], [[1218]]. Tekst \u0142ac. poz. [[1220]], niem. poz. [[1189]], w\u0142oski poz. [[1225]]",
        "datestamp": "2009-07-08 21:26:36",
        "place_of_pub": "[B. m. dr.]",
        "full_text_status": "public",
        "eprintid": 12190,
        "status_changed": "2009-07-08 21:26:36",
        "sheet_format": "4\u00b0",
        "short_title": "Relacja wjazdu solennego do Krakowa kr\u00f3la polskiego i praeliminaria actus coronationis",
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/12190",
        "full_metadata": "- [B. m. dr., po 16 IX 1697]. 4\u00b0. Knlb. 6, sygn. A4 B1. Wyd. C.\r\nE. - K\u0142odz. 172.\r\n[Tytu\u0142 nag\u0142., listewka, poni\u017cej, ant.:] RELATIA POLSKA, !1 SOLENNEGO WIAZDV, || Do Sto\u0142ecznego Miasta 1. K. M.\r\nKrakowa y || Zamku, z i\u00e1k naywi\u0119ksz\u0105 Magnificent t\u0105, || y Pomp\u0105. ||\r\n[kurs.:] NAIASNIEYSZEGO, y NIEZWYCI\u0118\u017bONEGO || Jant.:] KR\u00d3LA IEGOMOSCI || POLSKIEGO; &c. &c. || XIAZECIA\r\nDZIEDZICZNEGO, y ELE- ! KT\u00d3RA SASKIEGO, &c. &c. I! Odprawionego, [kurs.:] Die 12. Septembris, [ant.:] y [kurs.:]\r\nconsequenter J| Praeliminaria Actus Coronationis [ant.:] opisane, ||",
        "sheet_signing": "Sygn. A^4^B^2^",
        "rev_number": 24,
        "dictionary": [
            {
                "explanation": "uroczysty, podnios\u0142y",
                "entry": "solenny"
            },
            {
                "explanation": "przepych, wspania\u0142o\u015b\u0107",
                "entry": "magnificencyja "
            },
            {
                "explanation": "\u015bwi\u0119ci",
                "entry": "SS."
            },
            {
                "explanation": "wielmo\u017cni",
                "entry": "WW."
            },
            {
                "explanation": "ojcowie ",
                "entry": "OO. "
            },
            {
                "explanation": "z rozkazu kr\u00f3lewskiego ",
                "entry": "ordynans "
            },
            {
                "explanation": "by\u0107 gotowym ",
                "entry": "by\u0107 pogotowiu "
            },
            {
                "explanation": "jegomo\u015b\u0107",
                "entry": "Im\u015b\u0107 "
            },
            {
                "explanation": "pe\u0142en buty; wystawny",
                "entry": "buczny "
            },
            {
                "explanation": "Jego Kr\u00f3lewska Mo\u015b\u0107",
                "entry": "I.K.M. "
            },
            {
                "explanation": "mundur, uniform",
                "entry": "barwa "
            },
            {
                "explanation": "oddzia\u0142 jazdy, szwadron ",
                "entry": "kornet "
            },
            {
                "explanation": "o wojsku: w ordynku, w szyku",
                "entry": "w sprawie "
            },
            {
                "explanation": "tu: zbroja",
                "entry": "\u017cele\u017ace "
            },
            {
                "explanation": "\u017co\u0142nierz jazdy ci\u0119\u017ckiej, okryty pancerzem",
                "entry": "kirasjer "
            },
            {
                "explanation": "jednakowy",
                "entry": "jednostajny "
            },
            {
                "explanation": "muzykant graj\u0105cy na piszcza\u0142ce, flecie, oboju itp. ",
                "entry": "fajfer "
            },
            {
                "explanation": "lamowany, obszywany lam\u00f3wk\u0105",
                "entry": "bramowany "
            },
            {
                "explanation": "rodzaj kurtki \u017co\u0142nierskiej",
                "entry": "kolet "
            },
            {
                "explanation": "rodzaj ma\u015bci ko\u0144skiej",
                "entry": "skaragniady"
            },
            {
                "explanation": "ozdobiony pi\u00f3rami, pi\u00f3ropuszami",
                "entry": "pod pi\u00f3rami "
            },
            {
                "explanation": "ko\u0144 id\u0105cy lu\u017ano (niezaprz\u0119\u017cony,  bez je\u017ad\u017aca)",
                "entry": "ko\u0144 powodny"
            },
            {
                "explanation": "pow\u0142oka, pokrowiec",
                "entry": "koperta "
            },
            {
                "explanation": "pokrowiec, narzuta, przykrycie",
                "entry": "deka "
            },
            {
                "explanation": null,
                "entry": "fiski "
            },
            {
                "explanation": null,
                "entry": "poszoszny (ko\u0144)"
            },
            {
                "explanation": null,
                "entry": "czat\u0142os "
            },
            {
                "explanation": "fr\u0119dzla b\u0119d\u0105ca ozdob\u0105 uprz\u0119\u017cy konia",
                "entry": "fiok "
            },
            {
                "explanation": "o ma\u015bci konia: brunatno\u017c\u00f3\u0142ty",
                "entry": "izabelowy "
            },
            {
                "explanation": "o ma\u015bci konia: szaro\u017c\u00f3\u0142ty",
                "entry": "wilczaty  "
            },
            {
                "explanation": "\u017co\u0142nierz stra\u017cy przybocznej kr\u00f3la",
                "entry": "drabant "
            },
            {
                "explanation": "umundurowany, ubrany w mundur, w liberi\u0119",
                "entry": "barwiany "
            },
            {
                "explanation": "urz\u0119dnicy koronni ",
                "entry": "urz\u0119dnicy kor"
            },
            {
                "explanation": "Wielkie Ksi\u0119stwo Litewskie",
                "entry": "W. X. L. "
            },
            {
                "explanation": "opaska ",
                "entry": "binda "
            },
            {
                "explanation": "pos\u0142uszny, uleg\u0142y, daj\u0105cy \u0142atwo sob\u0105 powodowa\u0107",
                "entry": "powolny ko\u0144 "
            },
            {
                "explanation": "tj. arkebuzer (arkabuzer), \u017co\u0142nierz jazdy ci\u0119\u017ckiej uzbrojony w arkebuz",
                "entry": "archibuzier"
            },
            {
                "explanation": "Ja\u015bnie O\u015bwiecony Ksi\u0105\u017c\u0119 Jegomo\u015b\u0107 Ksi\u0105dz Biskup",
                "entry": "I. O. X.  Im\u015b\u0107 X. Biskup "
            },
            {
                "explanation": "p\u0142aszcz rzymski z jednego kawa\u0142ka materia\u0142u spi\u0119ty na jednym ramieniu",
                "entry": "paludament"
            },
            {
                "explanation": "przystosowany; tu: przybrany, udekorowany",
                "entry": "akomodowany"
            },
            {
                "explanation": "drogi kamie\u0144 czerwonej barwy: rubin, granat",
                "entry": "karbunku\u0142 "
            },
            {
                "explanation": "wed\u0142ug ksi\u0105\u017c\u0119cego zwyczaju",
                "entry": "wed\u0142ug Xcego zwyczaju "
            },
            {
                "explanation": "tu: przybrane; dostosowane (do okazji) ",
                "entry": "akordowany "
            },
            {
                "explanation": "po\u015bwi\u0119cenie, b\u0142ogos\u0142awie\u0144stwo, konsekracja",
                "entry": "benedykcyja "
            },
            {
                "explanation": "zako\u0144czenie",
                "entry": "konkluzyja "
            }
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "number": 1219,
        "sheets": "Knlb. 6",
        "lastmod": "2009-12-14 16:25:46",
        "eprint_status": "archive",
        "edition": "C",
        "dir": "disk0/00/01/21/90",
        "metadata_visibility": "show",
        "sources": "E. - K\u0142odz. 172",
        "year": 1697,
        "documents": [
            {
                "main": "Z1219.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30518",
                        "filesize": 344833,
                        "fileid": 30518,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10006r.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30519",
                        "filesize": 313372,
                        "fileid": 30519,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10005r.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30520",
                        "filesize": 3635974,
                        "fileid": 30520,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10008.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30521",
                        "filesize": 3014019,
                        "fileid": 30521,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10005l.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30522",
                        "filesize": 348352,
                        "fileid": 30522,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10007l.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30523",
                        "filesize": 354870,
                        "fileid": 30523,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10004l.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30524",
                        "filesize": 3353776,
                        "fileid": 30524,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10002.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30525",
                        "filesize": 354781,
                        "fileid": 30525,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10002.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30526",
                        "filesize": 2870984,
                        "fileid": 30526,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10007l.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30527",
                        "filesize": 2482368,
                        "fileid": 30527,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10004r.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30528",
                        "filesize": 3551241,
                        "fileid": 30528,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10003l.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30529",
                        "filesize": 384289,
                        "fileid": 30529,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10008.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30530",
                        "filesize": 3151432,
                        "fileid": 30530,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10006l.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30531",
                        "filesize": 110,
                        "fileid": 30531,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "Z1219.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30532",
                        "filesize": 351948,
                        "fileid": 30532,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10006l.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30533",
                        "filesize": 36486778,
                        "fileid": 30533,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "Z1219.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30534",
                        "filesize": 400806,
                        "fileid": 30534,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10003l.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30535",
                        "filesize": 356255,
                        "fileid": 30535,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10005l.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30536",
                        "filesize": 2847769,
                        "fileid": 30536,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10007r.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30537",
                        "filesize": 337227,
                        "fileid": 30537,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10007r.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30538",
                        "filesize": 350593,
                        "fileid": 30538,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10003r.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30539",
                        "filesize": 2491083,
                        "fileid": 30539,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10005r.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30540",
                        "filesize": 303721,
                        "fileid": 30540,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10004r.djvu"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30541",
                        "filesize": 3106627,
                        "fileid": 30541,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10004l.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30542",
                        "filesize": 3003952,
                        "fileid": 30542,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10003r.pdf"
                    },
                    {
                        "objectid": 518,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30543",
                        "filesize": 2982799,
                        "fileid": 30543,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "10006r.pdf"
                    }
                ],
                "docid": 518,
                "uri": "https://cbdu.ijp.pan.pl/id/document/518",
                "rev_number": 1,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "Z1219.pdf",
                "pos": 2,
                "files": [
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30544",
                        "filesize": 347640,
                        "fileid": 30544,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0004l.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30545",
                        "filesize": 3358208,
                        "fileid": 30545,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30546",
                        "filesize": 110,
                        "fileid": 30546,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "Z1219.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30547",
                        "filesize": 346242,
                        "fileid": 30547,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0006r.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30548",
                        "filesize": 2471852,
                        "fileid": 30548,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0005r.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30549",
                        "filesize": 348415,
                        "fileid": 30549,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0006l.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30550",
                        "filesize": 3525389,
                        "fileid": 30550,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0003l.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30551",
                        "filesize": 302612,
                        "fileid": 30551,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0004r.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30552",
                        "filesize": 341558,
                        "fileid": 30552,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0007l.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30553",
                        "filesize": 3027935,
                        "fileid": 30553,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0004l.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30554",
                        "filesize": 334141,
                        "fileid": 30554,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0007r.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30555",
                        "filesize": 381797,
                        "fileid": 30555,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0008.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30556",
                        "filesize": 2466825,
                        "fileid": 30556,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0004r.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30557",
                        "filesize": 3022592,
                        "fileid": 30557,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0003r.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30558",
                        "filesize": 353074,
                        "fileid": 30558,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0005l.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30559",
                        "filesize": 313276,
                        "fileid": 30559,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0005r.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30560",
                        "filesize": 3014052,
                        "fileid": 30560,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0006r.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30561",
                        "filesize": 3579103,
                        "fileid": 30561,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0008.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30562",
                        "filesize": 36185222,
                        "fileid": 30562,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "Z1219.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30563",
                        "filesize": 2869231,
                        "fileid": 30563,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0007r.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30564",
                        "filesize": 354306,
                        "fileid": 30564,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0002.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30565",
                        "filesize": 400883,
                        "fileid": 30565,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0003l.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30566",
                        "filesize": 2804264,
                        "fileid": 30566,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0007l.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30567",
                        "filesize": 353651,
                        "fileid": 30567,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0003r.djvu"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30568",
                        "filesize": 3093508,
                        "fileid": 30568,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0006l.pdf"
                    },
                    {
                        "objectid": 1196,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/30569",
                        "filesize": 2957509,
                        "fileid": 30569,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:05:50",
                        "filename": "0005l.pdf"
                    }
                ],
                "docid": 1196,
                "uri": "https://cbdu.ijp.pan.pl/id/document/1196",
                "rev_number": 1,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/518"
                    }
                ],
                "pos": 11,
                "files": [
                    {
                        "objectid": 10096,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52386",
                        "filesize": 88370,
                        "hash_type": "MD5",
                        "fileid": 52386,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:59:59",
                        "hash": "117afb0d6c06acc1fa8943a44a8f4b9d",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 10096,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10096",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 11,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/518"
                    }
                ],
                "pos": 12,
                "files": [
                    {
                        "objectid": 10097,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52387",
                        "filesize": 37138,
                        "hash_type": "MD5",
                        "fileid": 52387,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:00:00",
                        "hash": "e0c32a59e12bd3b19c972f877526b0cb",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 10097,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10097",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 12,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/518"
                    }
                ],
                "pos": 13,
                "files": [
                    {
                        "objectid": 10098,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52388",
                        "filesize": 10011,
                        "hash_type": "MD5",
                        "fileid": 52388,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:00:01",
                        "hash": "ff3bccca7b4d9d867add0a1d8c40f78b",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 10098,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10098",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 13,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/518"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/518"
                    }
                ],
                "pos": 14,
                "files": [
                    {
                        "objectid": 10099,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52389",
                        "filesize": 2076,
                        "hash_type": "MD5",
                        "fileid": 52389,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:00:02",
                        "hash": "7d85f6034ce81c05571152c846ea41d8",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 10099,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10099",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 14,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/1196"
                    }
                ],
                "pos": 15,
                "files": [
                    {
                        "objectid": 12770,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55063",
                        "filesize": 87761,
                        "hash_type": "MD5",
                        "fileid": 55063,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:44:37",
                        "hash": "96183eda9c6d5d30b7b8f1c49ccfc5c6",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 12770,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12770",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 15,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/1196"
                    }
                ],
                "pos": 16,
                "files": [
                    {
                        "objectid": 12771,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55064",
                        "filesize": 36552,
                        "hash_type": "MD5",
                        "fileid": 55064,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:44:38",
                        "hash": "116c9cb701c47f51eb645b7b1304e70f",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 12771,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12771",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 16,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/1196"
                    }
                ],
                "pos": 17,
                "files": [
                    {
                        "objectid": 12772,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55065",
                        "filesize": 9956,
                        "hash_type": "MD5",
                        "fileid": 55065,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:44:38",
                        "hash": "4a268d780c0204befd805bd9cd12e91b",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 12772,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12772",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 17,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1196"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/1196"
                    }
                ],
                "pos": 18,
                "files": [
                    {
                        "objectid": 12773,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55066",
                        "filesize": 2050,
                        "hash_type": "MD5",
                        "fileid": 55066,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:44:39",
                        "hash": "e5bbf872b83a2b5365fe50d22222ad98",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 12773,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12773",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 18,
                "rev_number": 2,
                "security": "public",
                "eprintid": 12190,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "microfilms": "BN Mf. 37925",
        "general_commentary": "#Jest to polska podstawa przek\u0142ad\u00f3w na trzy j\u0119zyki: \u0142acin\u0119, niemiecki i w\u0142oski. Na \u0142acin\u0119 i niemiecki t\u0142umaczono bezpo\u015brednio z j\u0119zyka polskiego, co zaznaczono w druku, natomiast dla przek\u0142adu na j\u0119zyk w\u0142oski podstaw\u0105 m\u00f3g\u0142 by\u0107 tekst \u0142aci\u0144ski. Tekst w\u0142oski, bed\u0105cy raczej adaptacj\u0105 ni\u017c t\u0142umaczeniem, jest ponadto du\u017co kr\u00f3tszy ni\u017c polski (4 strony tekstu w\u0142oskiego wobec 14 stron tekstu polskiego), podczas gdy teksty \u0142aci\u0144ski i niemiecki s\u0105 zbli\u017cone obj\u0119to\u015bciowo do orygina\u0142u",
        "copies": [
            "PAN K\u00f3rn. 1211"
        ],
        "full_title": "[Tytu\u0142 nag\u0142., listewka, poni\u017cej, ant.:] RELATIA POLSKA, || SOLENNEGO WIAZDV, || Do Sto\u0142ecznego Mi\u00e1st\u00e1 I. K. M. Kr\u00e1kow\u00e1 y || Zamku, z i\u00e1k naywi\u0119ksz\u0105 M\u00e1gnificenti\u0105, || y Pomp\u0105. || [kurs.:] NAIASNIEYSZEGO, y NIEZWYCIEZONEGO || [ant.:] KROLA IEGOMOSCI || POLSKIEGO; &c. &c. || XI\u0104Z\u0118CIA DZIEDZICZNEGO, y ELE- || KTORA SASKIEGO, &c. &c. || Odpr\u00e1wionego, [kurs.:] Die 12. Septembris, [ant.:] y [kurs.:] consequenter || Praeliminaria Act\u00fbs Coronationis [ant.:] opis\u00e1ne. ||",
        "date_of_pub": "[po 16 IX 1697]",
        "title": "Relacja wjazdu solennego do Krakowa kr\u00f3la polskiego i praeliminaria actus coronationis"
    },
    {
        "number": 1573,
        "userid": 3,
        "datestamp": "2009-07-08 21:26:23",
        "place_of_pub": "Krak\u00f3w",
        "full_text_status": "public",
        "sheets": "Knlb. 2",
        "eprintid": 15730,
        "lastmod": "2009-10-21 13:58:28",
        "abstract": "Zawiera: \u201eZ Rzymu 8. 7bris.\u201d. \u201eZ Mil\u00e1nu 10. 7bris.\u201d. \u201eZ M\u00e1drydu 27. Augusti.\u201d. \u201eZ P\u00e1ry\u017c\u00e1 5. Septembris.\u201d. \u201eEx Imperio z Obozu pod Landau de data 12 Septembris.\u201d. \u201eZ Wiedni\u00e1 24. Septembris.\u201d. \u201eZ W\u00e1r\u00df\u00e1wy 1ma 8bris.\u201d. \u201eZe Lwowa 24. Septembris.\u201d",
        "eprint_status": "archive",
        "status_changed": "2009-07-08 21:26:23",
        "dir": "disk0/00/01/57/30",
        "sources": "E. -",
        "metadata_visibility": "show",
        "sheet_format": "4\u00b0",
        "year": 1704,
        "documents": [
            {
                "main": "Z1573.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37835",
                        "filesize": 9249332,
                        "fileid": 37835,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0004.pdf"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37836",
                        "filesize": 2449969,
                        "fileid": 37836,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0002.djvu"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37837",
                        "filesize": 6288891,
                        "fileid": 37837,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0005.pdf"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37838",
                        "filesize": 3257281,
                        "fileid": 37838,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0004.djvu"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37839",
                        "filesize": 7625030,
                        "fileid": 37839,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37840",
                        "filesize": 32784094,
                        "fileid": 37840,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "Z1573.pdf"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37841",
                        "filesize": 68,
                        "fileid": 37841,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "Z1573.djvu"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37842",
                        "filesize": 9622274,
                        "fileid": 37842,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0003.pdf"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37843",
                        "filesize": 3444345,
                        "fileid": 37843,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0003.djvu"
                    },
                    {
                        "objectid": 442,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/37844",
                        "filesize": 2004789,
                        "fileid": 37844,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:07:30",
                        "filename": "0005.djvu"
                    }
                ],
                "docid": 442,
                "uri": "https://cbdu.ijp.pan.pl/id/document/442",
                "rev_number": 1,
                "security": "public",
                "eprintid": 15730,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/442"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 9800,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52090",
                        "filesize": 71884,
                        "hash_type": "MD5",
                        "fileid": 52090,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:54:16",
                        "hash": "57bf553ceae2e3932bbda3b91851a97d",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 9800,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9800",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15730,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/442"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 9801,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52091",
                        "filesize": 27719,
                        "hash_type": "MD5",
                        "fileid": 52091,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:54:17",
                        "hash": "28803fe081c13c0f8c7c8084883c483d",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 9801,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9801",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15730,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/442"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 9802,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52092",
                        "filesize": 6813,
                        "hash_type": "MD5",
                        "fileid": 52092,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:54:18",
                        "hash": "17a6292ba17a184567c38d5a39a7cbe8",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 9802,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9802",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15730,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/442"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/442"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 9803,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52093",
                        "filesize": 1698,
                        "hash_type": "MD5",
                        "fileid": 52093,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:54:19",
                        "hash": "0bee0712db86d38291a8c44f0314dc55",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 9803,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9803",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 15730,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/15730",
        "full_metadata": "[Tytu\u0142 nag\u0142., kurs.:] Wiadomo\u015bci ro\u017cne Cudzoziemskie w Kr\u00e1k: wydane 4. Sbris 1704. ||4\u00b0. Knlb. 2, b. sygn.\r\nZawiera: \u201eZ Rzymu 8. 7bris.\u201d. \u201eZ Mil\u00e1nu 10. 7bris.\u201d. \u201eZ M\u00e1drydu 27. Augusti.\u201d. \u201eZ Pary\u017ca 5. Septembris.\u201d. \u201eEx Imperio z\r\nObozu pod Landau de data 12 Septembris.\u201d. \u201eZ Wiednia 24. Septembris.\u201d. \u201eZ War\u00dfawy Ima Sbris.\u201d'. \u201eZe Lwowa 24.\r\nSeptembris.\u201d\r\nE. -",
        "publisher": "[B. dr.]",
        "microfilms": "BN Mf. 30292",
        "sheet_signing": "b. sygn.",
        "rev_number": 7,
        "historical_commentary": "Wiadomo\u015bci zagraniczne koncentruj\u0105 si\u0119 na doniesieniach z front\u00f3w wojny o sukcesj\u0119 hiszpa\u0144sk\u0105: z p\u00f3\u0142nocnych W\u0142och z okolic Mediolanu; z Hiszpanii (zdobycie Gibraltaru przez Anglik\u00f3w oraz umocnienie si\u0119 austriackiego pretendenta do tronu Hiszpanii Karola, zwanego Don Carlosem w Portugalii, kt\u00f3ra przesz\u0142a na stron\u0119 Koalicji w roku poprzednim); z Francji doniesienia o reakcjach na kl\u0119sk\u0119 armii francusko-bawarskiej pod Blenheim 13 VIII 1704 (wspomniany w tek\u015bcie Ksi\u0105\u017c\u0119 Delfin to jedyny doros\u0142y syn Ludwika XIV i Marii Teresy Habsburg, zwany Wielkim Delfinem. Wiadomo\u015bci z kraju dotycz\u0105 g\u0142\u00f3wnie ruch\u00f3w wojsk szwedzkich na Ukrainie (w rejonie Lwowa i \u017b\u00f3\u0142kwi), plan\u00f3w wsp\u00f3\u0142pracy z si\u0142ami hetmana Mazepy oraz sytuacji \"elekta\" czyli Stanis\u0142awa Leszczy\u0144skiego.",
        "copies": [
            "BN rps III 6652 k. 175-176"
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "full_title": "[Tytu\u0142 nag\u0142., kurs.:] Wiadomo\u015b\u0107i ro\u017cne Cudzo\u017aiemskie w Kr\u00e1k: wyd\u00e1ne 4. 8bris 1704. ||",
        "title": "Wiadomo\u015b\u0107i ro\u017cne Cudzo\u017aiemskie w Kr\u00e1k: wyd\u00e1ne 4. 8bris 1704. "
    },
    {
        "number": 1447,
        "userid": 3,
        "datestamp": "2009-07-08 21:28:28",
        "place_of_pub": "Krak\u00f3w",
        "full_text_status": "public",
        "sheets": "K. 1",
        "eprintid": 14470,
        "lastmod": "2009-12-19 12:53:04",
        "eprint_status": "archive",
        "status_changed": "2009-07-08 21:28:28",
        "dir": "disk0/00/01/44/70",
        "sources": "E. XXXII 415. GK. 726",
        "metadata_visibility": "show",
        "sheet_format": "4\u00b0",
        "year": 1698,
        "documents": [
            {
                "main": "Z1447.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 244,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/35709",
                        "filesize": 6381465,
                        "fileid": 35709,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:49",
                        "filename": "0003.pdf"
                    },
                    {
                        "objectid": 244,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/35710",
                        "filesize": 7114423,
                        "fileid": 35710,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:49",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 244,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/35711",
                        "filesize": 677312,
                        "fileid": 35711,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:49",
                        "filename": "0002.djvu"
                    },
                    {
                        "objectid": 244,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/35712",
                        "filesize": 56,
                        "fileid": 35712,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:49",
                        "filename": "Z1447.djvu"
                    },
                    {
                        "objectid": 244,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/35713",
                        "filesize": 13495411,
                        "fileid": 35713,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:06:49",
                        "filename": "Z1447.pdf"
                    },
                    {
                        "objectid": 244,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/35714",
                        "filesize": 598637,
                        "fileid": 35714,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:06:49",
                        "filename": "0003.djvu"
                    }
                ],
                "docid": 244,
                "uri": "https://cbdu.ijp.pan.pl/id/document/244",
                "rev_number": 1,
                "security": "public",
                "eprintid": 14470,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/244"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 9016,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51306",
                        "filesize": 85442,
                        "hash_type": "MD5",
                        "fileid": 51306,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:40:43",
                        "hash": "fde9c6a2422ec2307c2ad93495b7bf7b",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 9016,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9016",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14470,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/244"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 9017,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51307",
                        "filesize": 34053,
                        "hash_type": "MD5",
                        "fileid": 51307,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:40:43",
                        "hash": "a0efc1f426456cf4a0965709eefac27b",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 9017,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9017",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14470,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/244"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 9018,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51308",
                        "filesize": 8783,
                        "hash_type": "MD5",
                        "fileid": 51308,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:40:44",
                        "hash": "c26b6280c98c4e1cbf758dcd5d867053",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 9018,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9018",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14470,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/244"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/244"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 9019,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51309",
                        "filesize": 1658,
                        "hash_type": "MD5",
                        "fileid": 51309,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:40:45",
                        "hash": "98cde99faf8ccc974a86c54445d89e11",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 9019,
                "uri": "https://cbdu.ijp.pan.pl/id/document/9019",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 14470,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/14470",
        "full_metadata": "[Tytu\u0142 nag\u0142., ant.:] Wiadomo\u015bci Warszawskie, Lwowskie, Litewskie, z Kr\u00e1 || kowa 1.Martij. 1698. ||4\u00b0. K. 1.\r\nE. XXXII 415. GK. 726",
        "microfilms": "BN Mf. 25009",
        "rev_number": 14,
        "dictionary": [
            {
                "explanation": "z powrotem",
                "entry": "nazad"
            },
            {
                "explanation": "przypuszcza\u0107, spodziewa\u0107 si\u0119, mie\u0107 nadziej\u0119",
                "entry": "tuszy\u0107"
            },
            {
                "explanation": "rozs\u0105dny",
                "entry": "rozsadny"
            },
            {
                "explanation": "obowi\u0105zek",
                "entry": "oblig"
            },
            {
                "explanation": "odzyskanie",
                "entry": "windykowanie"
            },
            {
                "explanation": "przypodoba\u0107 si\u0119",
                "entry": "accomodowa\u0107 si\u0119"
            },
            {
                "explanation": null,
                "entry": "prorogowany"
            },
            {
                "explanation": "kredytowy",
                "entry": "borgowy"
            },
            {
                "explanation": "op\u0142ata na \u017cywno\u015b\u0107 dla wojska",
                "entry": "hiberna"
            },
            {
                "explanation": "ulga",
                "entry": "folga"
            },
            {
                "explanation": "zaopatrzy\u0107, zapewni\u0107",
                "entry": "prowidowa\u0107"
            },
            {
                "explanation": "pozbycie si\u0119, tu: wycofanie  z u\u017cycia, z obiegu",
                "entry": "wygubienie"
            },
            {
                "explanation": "monety (z mniejsz\u0105 zawarto\u015bci\u0105 srebra) wybijane w Prusach Krzy\u017cackich, dostaj\u0105ce si\u0119 do systemu monetarnego w Prusach Kr\u00f3lewskich i Rzeczypospolitej, powoduj\u0105ce spadek warto\u015bci pieni\u0105dza",
                "entry": "z\u0142a moneta"
            },
            {
                "explanation": "sejm zwo\u0142ywany w obozach pospolitego ruszenia",
                "entry": "sejm konny"
            },
            {
                "explanation": "wtargni\u0119cie, najazd, napad",
                "entry": "inkursja"
            }
        ],
        "historical_commentary": "Dotyczy sytuacji po podw\u00f3jnej elekcji 1697 - pretendenta francuskiego ksi\u0119cia Conti oraz Augusta II, elektora saskiego i obj\u0119ciu w\u0142adzy przez tego drugiego. Ksi\u0105\u017c\u0119 Conti, po elekcji w Warszawie, og\u0142oszony zosta\u0142 kr\u00f3lem przez prymasa Radziejowskiego, przyw\u00f3dc\u0119 jego stronnik\u00f3w, 3 VI 1697, jednak wobec szybkiego przej\u0119cia w\u0142adzy przez konkurenta w og\u00f3le nie do\u0142\u0105czy\u0142 do swych zwolennik\u00f3w i 7 XI 1697 odp\u0142yn\u0105\u0142 z portu w Oliwie, tym samym rezygnuj\u0105c z praw do korony. Wspomniane w tek\u015bcie wojska, kt\u00f3rych wej\u015bcie na teren Rzeczpospolitej mia\u0142oby narusza\u0107 \"polsk\u0105 wolno\u015b\u0107\" to oddzia\u0142y saskie Augusta II. Jako podlegaj\u0105ce bezpo\u015brednio kr\u00f3lowi w pierwszych latach panowania budzi\u0142y one wiele kontrowersji i obaw po\u015br\u00f3d szlachty. Apogeum tego konfliktu mia\u0142o nast\u0105pi\u0107 we wrze\u015bniu 1698 w obozie pod Brze\u017canami podczas wyprawy przeciw Turkom, kt\u00f3rej podj\u0119cie stanowi\u0142o jedn\u0105 z kluczowych przedwyborczych obietnic Augusta, gdzie omal nie dosz\u0142o do bitwy mi\u0119dzy oddzia\u0142ami polskimi i saskimi. Kr\u00f3lowa, o kt\u00f3rej wspomina si\u0119 w tek\u015bcie, to wdowa po Janie III Sobieskim.",
        "copies": [
            "Ossol. Cz-123-III"
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "full_title": "[Tytu\u0142 nag\u0142., ant.:] Wi\u00e1domo\u015b\u0107i W\u00e1rsz\u00e1wskie, Lwowskie, Litewskie, z Kr\u00e1 || kowa 1. Martij. 1698. ||",
        "title": "Wi\u00e1domo\u015b\u0107i W\u00e1rsz\u00e1wskie, Lwowskie, Litewskie, z Kr\u00e1 kowa 1. Martij. 1698. "
    },
    {
        "userid": 3,
        "datestamp": "2009-07-08 21:25:07",
        "place_of_pub": "[Krak\u00f3w]",
        "full_text_status": "public",
        "eprintid": 990,
        "status_changed": "2009-07-08 21:25:07",
        "sheet_format": "4\u00b0",
        "short_title": "Wjazd Henryka Walezjusza do Reims na koronacj\u0119 Kr\u00f3lestwa Francuskiego",
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/990",
        "full_metadata": "Wjazd Henryka Walezjusza do Reims na koronacj\u0119 Kr\u00f3lestwa Francuskiego. [Krak\u00f3w, Mateusz Siebeneycher,\r\npo 15 II 1575]. 4\u00b0. Knlb. 8, sygn. A-B^4^.\r\nE. XVIII 109.\r\n[Tytu\u0142, frakt.:] Wiazd Kr\u00f3la Je-|| go Milo\u015bci Polskiego Henryk\u00e1 || Walezyus\u00e1 do Rensu/ n\u00e1 koron\u00e1cy\u0105 || Kr\u00f3lestw\u00e1\r\nFr\u00e1ncuskiego / Dni\u00e1 ie- || dennastego Lutego / Roku 1575. || spo\u0142em z opis\u00e1nim ceremoniej / t\u00e1k po || m\u00e1z\u00e1nia n\u00e1\r\nKrolestwo / i\u00e1ko y || wesela mal\u017ce\u0144skiego / krotko \u00e1 || prawdziwie vc\u017ayniony. || [dwa obok siebie umieszczone\r\nozdobniki] || [plecionka drzeworytowa] ||\r\n\r\nWG: Wprowadzi\u0142em korekt\u0119 tytu\u0142u pe\u0142nego, sprawdzi\u0142em pozosta\u0142e pola.",
        "publisher": "[Mateusz Siebeneycher]",
        "sheet_signing": "Sygn. A-B^4^",
        "rev_number": 28,
        "dictionary": [
            {
                "explanation": "o nieszpornej godzinie, tzn. wieczorem, w porze nieszpor\u00f3w",
                "entry": "o niespornej godzinie"
            },
            {
                "explanation": "rozpocz\u0105\u0107 strzelanie",
                "entry": "strzelb\u0119 pu\u015bci\u0107"
            },
            {
                "explanation": "opr\u00f3cz",
                "entry": "okrom"
            },
            {
                "explanation": "ze spisami, pikami",
                "entry": "z spiszy"
            },
            {
                "explanation": "baldachim",
                "entry": "umbela"
            },
            {
                "explanation": "zewn\u0119trzna pow\u0142oka",
                "entry": "koperta"
            },
            {
                "explanation": "w\u00f3z",
                "entry": "wos"
            },
            {
                "explanation": "na spodzie, od spodu",
                "entry": "na spodku"
            },
            {
                "explanation": "zrobiony z altenbasu - z\u0142otog\u0142owia, tkaniny o osnowie jedwabnej a w\u0105tku z\u0142otym",
                "entry": "altembasowy"
            },
            {
                "explanation": "szarfa? ta\u015bma?",
                "entry": "bandelin"
            },
            {
                "explanation": "tron",
                "entry": "majestat"
            },
            {
                "explanation": "ostatnia niedziela karnawa\u0142u, niedziela zapustna, pi\u0119\u0107dziesi\u0105tnica",
                "entry": "niedziela mi\u0119sopustna"
            },
            {
                "explanation": "gotowi, przygotowani",
                "entry": "byli po gotowiu"
            },
            {
                "explanation": "w ch\u00f3rze, do ch\u00f3ru, na ch\u00f3r (?)",
                "entry": "w kurze, do kuru, na kur "
            },
            {
                "explanation": "ksi\u0105\u017c\u0119 niemiecki, elektor",
                "entry": "kurfirst"
            },
            {
                "explanation": "tafta",
                "entry": "tawta"
            },
            {
                "explanation": "bieretek, rodzaj nakrycia g\u0142owy",
                "entry": "bierletek"
            },
            {
                "explanation": "ber\u0142o",
                "entry": "sceptrum"
            },
            {
                "explanation": "\u017co\u0142nierz ze stra\u017cy przybocznej kr\u00f3la",
                "entry": "drabant"
            },
            {
                "explanation": "tu: mundur",
                "entry": "barwa"
            },
            {
                "explanation": "rodzaj delikatnej tkaniny",
                "entry": "kitajka"
            },
            {
                "explanation": "rodzaj stroju liturgicznego",
                "entry": "dalmatyka"
            },
            {
                "explanation": "jednochodziec; ko\u0144 odznaczaj\u0105cy si\u0119 swoistym chodem, polegaj\u0105cym na jednoczesnym stawianiu obu n\u00f3g z tej samej strony cia\u0142a",
                "entry": "jednochodnik"
            },
            {
                "explanation": "je",
                "entry": "gi"
            },
            {
                "explanation": "herold",
                "entry": "hera\u0142d"
            },
            {
                "explanation": "fragment psalmu wybrany stosownie do uroczysto\u015bci czytany w czasie mszy \u015bw. przed ofiarowaniem chleba i wina",
                "entry": "oferta"
            },
            {
                "explanation": "zszed\u0142",
                "entry": "szczed\u0142"
            },
            {
                "explanation": "obicie z ozdobnej tkaniny",
                "entry": "opona"
            },
            {
                "explanation": "tkanina o w\u0105tku srebrnym",
                "entry": "srebrog\u0142\u00f3w"
            }
        ],
        "historical_commentary": "Rzecz dotyczy koronacji Henryka Walezego (de Valois, 1551- 1589) na kr\u00f3la Francji 11 II 1575, po \u015bmierci jego brata i jego ucieczce z Polski, gdzie panowa\u0142 jako pierwszy kr\u00f3l elekcyjny po wyga\u015bni\u0119ciu dynastii Jagiellon\u00f3w. Co charakterystyczne, narrator wci\u0105\u017c tytu\u0142uje go kr\u00f3lem Polski, jako \u017ce Henryk opu\u015bci\u0142 Rzeczpospolit\u0105 potajemnie, bez zrzeczenia si\u0119 tronu. Warto zwr\u00f3ci\u0107 uwag\u0119 na opis tradycyjnych szczeg\u00f3\u0142\u00f3w ceremonii koronacyjnej, w tym namaszczenie \u015bwi\u0119tymi olejami, oraz na list\u0119 jej uczestnik\u00f3w, w tym matk\u0119 kr\u00f3la - Katarzyn\u0119 Medycejsk\u0105, ksi\u0119cia de Guise i Henryka kr\u00f3la Nawarry - g\u0142\u00f3wnych aktor\u00f3w tzw. wojny trzech Henryk\u00f3w, trapi\u0105cej Francj\u0119 w trakcie panowania Henryka. Wzmiankowana w tek\u015bcie \"m\u0142oda kr\u00f3lowa\" to Ludwika Lotary\u0144ska (1553 - 1601), c\u00f3rka Miko\u0142aja Lotary\u0144skiego.",
        "type": "book",
        "language": [
            "pl"
        ],
        "number": 99,
        "sheets": "Knlb. 8",
        "lastmod": "2009-11-29 17:34:39",
        "eprint_status": "archive",
        "dir": "disk0/00/00/09/90",
        "metadata_visibility": "show",
        "sources": "E. XVIII 109",
        "year": 1575,
        "documents": [
            {
                "main": "Z99.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3162",
                        "filesize": 4757130,
                        "fileid": 3162,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0009r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3163",
                        "filesize": 4026184,
                        "fileid": 3163,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0005l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3164",
                        "filesize": 185726,
                        "fileid": 3164,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0004l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3165",
                        "filesize": 194539,
                        "fileid": 3165,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0008r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3166",
                        "filesize": 4589643,
                        "fileid": 3166,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0004l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3167",
                        "filesize": 205146,
                        "fileid": 3167,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0007r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3168",
                        "filesize": 2975425,
                        "fileid": 3168,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0003l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3169",
                        "filesize": 160629,
                        "fileid": 3169,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0005l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3170",
                        "filesize": 4522505,
                        "fileid": 3170,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0004r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3171",
                        "filesize": 210878,
                        "fileid": 3171,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:43",
                        "filename": "0005r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3172",
                        "filesize": 204065,
                        "fileid": 3172,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0006r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3173",
                        "filesize": 206140,
                        "fileid": 3173,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0003r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3174",
                        "filesize": 168081,
                        "fileid": 3174,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0008l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3175",
                        "filesize": 123,
                        "fileid": 3175,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "Z99.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3176",
                        "filesize": 178497,
                        "fileid": 3176,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0006l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3177",
                        "filesize": 4675219,
                        "fileid": 3177,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0003r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3178",
                        "filesize": 4318335,
                        "fileid": 3178,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0008l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3179",
                        "filesize": 4377097,
                        "fileid": 3179,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0009l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3180",
                        "filesize": 165900,
                        "fileid": 3180,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0009l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3181",
                        "filesize": 4651040,
                        "fileid": 3181,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0007r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3182",
                        "filesize": 3645470,
                        "fileid": 3182,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:44",
                        "filename": "0010.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3183",
                        "filesize": 4361629,
                        "fileid": 3183,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0002r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3184",
                        "filesize": 102498,
                        "fileid": 3184,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0010.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3185",
                        "filesize": 168461,
                        "fileid": 3185,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0007l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3186",
                        "filesize": 4718113,
                        "fileid": 3186,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0005r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3187",
                        "filesize": 4302152,
                        "fileid": 3187,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0007l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3188",
                        "filesize": 175307,
                        "fileid": 3188,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0002r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3189",
                        "filesize": 4662028,
                        "fileid": 3189,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0006r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3190",
                        "filesize": 4420891,
                        "fileid": 3190,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0006l.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3191",
                        "filesize": 4654551,
                        "fileid": 3191,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0008r.pdf"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3192",
                        "filesize": 204548,
                        "fileid": 3192,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0004r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3193",
                        "filesize": 102503,
                        "fileid": 3193,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0003l.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3194",
                        "filesize": 207499,
                        "fileid": 3194,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:00:45",
                        "filename": "0009r.djvu"
                    },
                    {
                        "objectid": 236,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/3195",
                        "filesize": 69650267,
                        "fileid": 3195,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:00:46",
                        "filename": "Z99.pdf"
                    }
                ],
                "docid": 236,
                "uri": "https://cbdu.ijp.pan.pl/id/document/236",
                "rev_number": 1,
                "security": "public",
                "eprintid": 990,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/236"
                    }
                ],
                "pos": 2,
                "files": [
                    {
                        "objectid": 8984,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51274",
                        "filesize": 49873,
                        "hash_type": "MD5",
                        "fileid": 51274,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:39:43",
                        "hash": "9ec8cf4c78a3755b6d8881d899c08ace",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 8984,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8984",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 2,
                "rev_number": 2,
                "security": "public",
                "eprintid": 990,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/236"
                    }
                ],
                "pos": 3,
                "files": [
                    {
                        "objectid": 8985,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51275",
                        "filesize": 22247,
                        "hash_type": "MD5",
                        "fileid": 51275,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:39:44",
                        "hash": "e03107f31bcd7e8bafdc6df85d71c194",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 8985,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8985",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 3,
                "rev_number": 2,
                "security": "public",
                "eprintid": 990,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/236"
                    }
                ],
                "pos": 4,
                "files": [
                    {
                        "objectid": 8986,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51276",
                        "filesize": 6855,
                        "hash_type": "MD5",
                        "fileid": 51276,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:39:46",
                        "hash": "d4fbe801e39a2e158751e61f820797b8",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 8986,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8986",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 4,
                "rev_number": 2,
                "security": "public",
                "eprintid": 990,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/236"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/236"
                    }
                ],
                "pos": 5,
                "files": [
                    {
                        "objectid": 8987,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/51277",
                        "filesize": 1766,
                        "hash_type": "MD5",
                        "fileid": 51277,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 07:39:48",
                        "hash": "84490d521b755188daac25a5e3510886",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 8987,
                "uri": "https://cbdu.ijp.pan.pl/id/document/8987",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 5,
                "rev_number": 2,
                "security": "public",
                "eprintid": 990,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "microfilms": "BN Mf. 4512",
        "general_commentary": "#Najprawdopodobniej jest to tak\u017ce przek\u0142ad dostosowany do czytelnika polskiego. Podstaw\u0119 stanowi\u0142 zapewne tekst francuski, o czym mo\u017ce \u015bwiadczy\u0107 stopie\u0144 dok\u0142adno\u015bci relacji. ",
        "copies": [
            "BN XVI. Qu. 548 adl"
        ],
        "full_title": "[Tytu\u0142, frakt.:] Wiazd Krol\u00e1 Je- || go Mi\u0142o\u015b\u0107i Polskiego Henryk\u00e1 || W\u00e1lezyus\u00e1 do Rensu / n\u00e1 koron\u00e1cy\u0105 || Krolestw\u00e1 Fr\u00e1ncuskiego / Dni\u00e1 ie- || dennastego Lutego / Roku 1575. || spo\u0142em z opis\u00e1nim ceremoniej / t\u00e1k po || m\u00e1z\u00e1nia n\u00e1 Krolestwo / i\u00e1ko y || wesela ma\u0142\u017ce\u0144skiego / krotko \u00e1 || prawdziwie vc\u017cyniony. || [dwa obok siebie umieszczone ozdobniki] || [plecionka drzeworytowa] ||",
        "date_of_pub": "[po 15 II 1575]",
        "title": "Wjazd Henryka Walezjusza do Reims na koronacj\u0119 Kr\u00f3lestwa Francuskiego"
    },
    {
        "number": 435,
        "userid": 3,
        "datestamp": "2009-07-08 21:26:05",
        "place_of_pub": "[B. m. dr.]",
        "full_text_status": "public",
        "sheets": "Knlb. 16",
        "eprintid": 4350,
        "lastmod": "2010-01-04 09:37:30",
        "edition": "B",
        "eprint_status": "archive",
        "status_changed": "2009-11-25 16:00:15",
        "dir": "disk0/00/00/43/50",
        "sources": "Por. E. XXIX 213. K\u0142odz. 89.",
        "metadata_visibility": "show",
        "sheet_format": "4\u00b0",
        "short_title": "Wyprawa i wyjazd su\u0142tana Amurata, cesarza tureckiego, na wojn\u0119 do Korony Polskiej",
        "year": 1634,
        "documents": [
            {
                "main": "Z435.pdf",
                "pos": 1,
                "files": [
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13758",
                        "filesize": 3044235,
                        "fileid": 13758,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10018.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13759",
                        "filesize": 2460801,
                        "fileid": 13759,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10003r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13760",
                        "filesize": 333345,
                        "fileid": 13760,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10010l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13761",
                        "filesize": 247672,
                        "fileid": 13761,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10018.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13762",
                        "filesize": 314559,
                        "fileid": 13762,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10012r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13763",
                        "filesize": 314020,
                        "fileid": 13763,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10008l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13764",
                        "filesize": 2374485,
                        "fileid": 13764,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10016r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13765",
                        "filesize": 290560,
                        "fileid": 13765,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10006r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13766",
                        "filesize": 2450587,
                        "fileid": 13766,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10005r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13767",
                        "filesize": 2360676,
                        "fileid": 13767,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10009r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13768",
                        "filesize": 2338985,
                        "fileid": 13768,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10007r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13769",
                        "filesize": 329847,
                        "fileid": 13769,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10007l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13770",
                        "filesize": 245634,
                        "fileid": 13770,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10017r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13771",
                        "filesize": 294890,
                        "fileid": 13771,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10005r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13772",
                        "filesize": 149636,
                        "fileid": 13772,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10003l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13773",
                        "filesize": 86546752,
                        "fileid": 13773,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "Z435.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13774",
                        "filesize": 2345814,
                        "fileid": 13774,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10013r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13775",
                        "filesize": 319220,
                        "fileid": 13775,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:51",
                        "filename": "10015r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13776",
                        "filesize": 298731,
                        "fileid": 13776,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10011r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13777",
                        "filesize": 2753951,
                        "fileid": 13777,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10002.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13778",
                        "filesize": 2660320,
                        "fileid": 13778,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10011l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13779",
                        "filesize": 307261,
                        "fileid": 13779,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10013r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13780",
                        "filesize": 2738590,
                        "fileid": 13780,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10005l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13781",
                        "filesize": 301589,
                        "fileid": 13781,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10008r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13782",
                        "filesize": 2837964,
                        "fileid": 13782,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10015r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13783",
                        "filesize": 324189,
                        "fileid": 13783,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10013l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13784",
                        "filesize": 2382017,
                        "fileid": 13784,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10004r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13785",
                        "filesize": 3580821,
                        "fileid": 13785,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10016l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13786",
                        "filesize": 3005665,
                        "fileid": 13786,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10017l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13787",
                        "filesize": 292444,
                        "fileid": 13787,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10009r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13788",
                        "filesize": 338703,
                        "fileid": 13788,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10014l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13789",
                        "filesize": 2887950,
                        "fileid": 13789,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10009l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13790",
                        "filesize": 316747,
                        "fileid": 13790,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10005l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13791",
                        "filesize": 3029108,
                        "fileid": 13791,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10008l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13792",
                        "filesize": 246473,
                        "fileid": 13792,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10017l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13793",
                        "filesize": 2870672,
                        "fileid": 13793,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10012l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13794",
                        "filesize": 260244,
                        "fileid": 13794,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10016r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13795",
                        "filesize": 2854292,
                        "fileid": 13795,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10006l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13796",
                        "filesize": 370797,
                        "fileid": 13796,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10015l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13797",
                        "filesize": 322509,
                        "fileid": 13797,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10003r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13798",
                        "filesize": 306018,
                        "fileid": 13798,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10009l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13799",
                        "filesize": 404943,
                        "fileid": 13799,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10016l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13800",
                        "filesize": 281560,
                        "fileid": 13800,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10004r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13801",
                        "filesize": 317152,
                        "fileid": 13801,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10011l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13802",
                        "filesize": 2305773,
                        "fileid": 13802,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10010r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13803",
                        "filesize": 2828892,
                        "fileid": 13803,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10004l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13804",
                        "filesize": 2644350,
                        "fileid": 13804,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10013l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13805",
                        "filesize": 2715333,
                        "fileid": 13805,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10008r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13806",
                        "filesize": 313600,
                        "fileid": 13806,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10014r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13807",
                        "filesize": 2372498,
                        "fileid": 13807,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10011r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13808",
                        "filesize": 293821,
                        "fileid": 13808,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10010r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13809",
                        "filesize": 305009,
                        "fileid": 13809,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10004l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13810",
                        "filesize": 2965741,
                        "fileid": 13810,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10014l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13811",
                        "filesize": 2929165,
                        "fileid": 13811,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10014r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13812",
                        "filesize": 314274,
                        "fileid": 13812,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10007r.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13813",
                        "filesize": 2410832,
                        "fileid": 13813,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10006r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13814",
                        "filesize": 2861516,
                        "fileid": 13814,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10007l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13815",
                        "filesize": 3001934,
                        "fileid": 13815,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10010l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13816",
                        "filesize": 2777204,
                        "fileid": 13816,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10012r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13817",
                        "filesize": 257922,
                        "fileid": 13817,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10002.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13818",
                        "filesize": 295754,
                        "fileid": 13818,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10006l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13819",
                        "filesize": 1661869,
                        "fileid": 13819,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10003l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13820",
                        "filesize": 3412697,
                        "fileid": 13820,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10015l.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13821",
                        "filesize": 317857,
                        "fileid": 13821,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10012l.djvu"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13822",
                        "filesize": 2696628,
                        "fileid": 13822,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "10017r.pdf"
                    },
                    {
                        "objectid": 590,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13823",
                        "filesize": 206,
                        "fileid": 13823,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "Z435.djvu"
                    }
                ],
                "docid": 590,
                "uri": "https://cbdu.ijp.pan.pl/id/document/590",
                "rev_number": 1,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "Z435.pdf",
                "pos": 2,
                "files": [
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13824",
                        "filesize": 279680,
                        "fileid": 13824,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0013r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13825",
                        "filesize": 3044235,
                        "fileid": 13825,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0018.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13826",
                        "filesize": 299567,
                        "fileid": 13826,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0012l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13827",
                        "filesize": 277282,
                        "fileid": 13827,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0009l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13828",
                        "filesize": 247463,
                        "fileid": 13828,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0017r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13829",
                        "filesize": 252701,
                        "fileid": 13829,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0010r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13830",
                        "filesize": 2717683,
                        "fileid": 13830,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0017r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13831",
                        "filesize": 266404,
                        "fileid": 13831,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0011r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13832",
                        "filesize": 261676,
                        "fileid": 13832,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0014r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13833",
                        "filesize": 269261,
                        "fileid": 13833,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0008r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13834",
                        "filesize": 302866,
                        "fileid": 13834,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0003.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13835",
                        "filesize": 2677052,
                        "fileid": 13835,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0012r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13836",
                        "filesize": 311823,
                        "fileid": 13836,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0007l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13837",
                        "filesize": 2242401,
                        "fileid": 13837,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0003.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13838",
                        "filesize": 2625221,
                        "fileid": 13838,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0005l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13839",
                        "filesize": 3133887,
                        "fileid": 13839,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0015l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13840",
                        "filesize": 294555,
                        "fileid": 13840,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0007r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13841",
                        "filesize": 254334,
                        "fileid": 13841,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0004r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13842",
                        "filesize": 2262697,
                        "fileid": 13842,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0007r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13843",
                        "filesize": 303602,
                        "fileid": 13843,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0016l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13844",
                        "filesize": 289897,
                        "fileid": 13844,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0008l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13845",
                        "filesize": 2239989,
                        "fileid": 13845,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0016r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13846",
                        "filesize": 257984,
                        "fileid": 13846,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0009r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13847",
                        "filesize": 2196158,
                        "fileid": 13847,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0010r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13848",
                        "filesize": 291055,
                        "fileid": 13848,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0011l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13849",
                        "filesize": 2263019,
                        "fileid": 13849,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0004r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13850",
                        "filesize": 2783338,
                        "fileid": 13850,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0010l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13851",
                        "filesize": 2671184,
                        "fileid": 13851,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0006l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13852",
                        "filesize": 2618114,
                        "fileid": 13852,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0004l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13853",
                        "filesize": 256010,
                        "fileid": 13853,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0006r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13854",
                        "filesize": 2503925,
                        "fileid": 13854,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0011l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13855",
                        "filesize": 2233347,
                        "fileid": 13855,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0009r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13856",
                        "filesize": 247672,
                        "fileid": 13856,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0018.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13857",
                        "filesize": 2357694,
                        "fileid": 13857,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0002.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13858",
                        "filesize": 2752899,
                        "fileid": 13858,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0012l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13859",
                        "filesize": 290670,
                        "fileid": 13859,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0005l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13860",
                        "filesize": 2904942,
                        "fileid": 13860,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0008l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13861",
                        "filesize": 2979238,
                        "fileid": 13861,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0017l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13862",
                        "filesize": 307642,
                        "fileid": 13862,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0013l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13863",
                        "filesize": 2271621,
                        "fileid": 13863,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0006r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13864",
                        "filesize": 290523,
                        "fileid": 13864,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0012r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13865",
                        "filesize": 2609750,
                        "fileid": 13865,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0015r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13866",
                        "filesize": 238162,
                        "fileid": 13866,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0002.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13867",
                        "filesize": 278661,
                        "fileid": 13867,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0015l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13868",
                        "filesize": 289738,
                        "fileid": 13868,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0014l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13869",
                        "filesize": 2282523,
                        "fileid": 13869,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0005r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13870",
                        "filesize": 2751843,
                        "fileid": 13870,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0014r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13871",
                        "filesize": 2228940,
                        "fileid": 13871,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0013r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13872",
                        "filesize": 3283903,
                        "fileid": 13872,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:52",
                        "filename": "0016l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13873",
                        "filesize": 244409,
                        "fileid": 13873,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0015r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13874",
                        "filesize": 80280088,
                        "fileid": 13874,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "Z435.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13875",
                        "filesize": 262841,
                        "fileid": 13875,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0005r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13876",
                        "filesize": 2729778,
                        "fileid": 13876,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0009l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13877",
                        "filesize": 244540,
                        "fileid": 13877,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0017l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13878",
                        "filesize": 302760,
                        "fileid": 13878,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0010l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13879",
                        "filesize": 202755,
                        "fileid": 13879,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0016r.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13880",
                        "filesize": 269749,
                        "fileid": 13880,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0006l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13881",
                        "filesize": 2539739,
                        "fileid": 13881,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0013l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13882",
                        "filesize": 2832626,
                        "fileid": 13882,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0014l.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13883",
                        "filesize": 278506,
                        "fileid": 13883,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0004l.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13884",
                        "filesize": 2278333,
                        "fileid": 13884,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0011r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13885",
                        "filesize": 2545952,
                        "fileid": 13885,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0008r.pdf"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13886",
                        "filesize": 198,
                        "fileid": 13886,
                        "datasetid": "document",
                        "mime_type": "image/vnd.djvu",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "Z435.djvu"
                    },
                    {
                        "objectid": 1237,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/13887",
                        "filesize": 2732206,
                        "fileid": 13887,
                        "datasetid": "document",
                        "mime_type": "application/pdf",
                        "mtime": "2020-04-23 10:02:53",
                        "filename": "0007l.pdf"
                    }
                ],
                "docid": 1237,
                "uri": "https://cbdu.ijp.pan.pl/id/document/1237",
                "rev_number": 1,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "application/pdf",
                "format": "application/pdf",
                "language": "en"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/590"
                    }
                ],
                "pos": 11,
                "files": [
                    {
                        "objectid": 10384,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52674",
                        "filesize": 65472,
                        "hash_type": "MD5",
                        "fileid": 52674,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:04:52",
                        "hash": "1311a73bab0124a293939402510e5cd6",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 10384,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10384",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 11,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/590"
                    }
                ],
                "pos": 12,
                "files": [
                    {
                        "objectid": 10385,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52675",
                        "filesize": 29148,
                        "hash_type": "MD5",
                        "fileid": 52675,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:04:53",
                        "hash": "99591bd4456422ecacdd009e509d01f3",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 10385,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10385",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 12,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/590"
                    }
                ],
                "pos": 13,
                "files": [
                    {
                        "objectid": 10386,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52676",
                        "filesize": 8416,
                        "hash_type": "MD5",
                        "fileid": 52676,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:04:55",
                        "hash": "956fae25f4481203df8c6b2c9816f162",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 10386,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10386",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 13,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/590"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/590"
                    }
                ],
                "pos": 14,
                "files": [
                    {
                        "objectid": 10387,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/52677",
                        "filesize": 2058,
                        "hash_type": "MD5",
                        "fileid": 52677,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:04:57",
                        "hash": "8fdc8449b365a64b8267843afce22c1e",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 10387,
                "uri": "https://cbdu.ijp.pan.pl/id/document/10387",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 14,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "lightbox.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/islightboxThumbnailVersionOf",
                        "uri": "/id/document/1237"
                    }
                ],
                "pos": 15,
                "files": [
                    {
                        "objectid": 12935,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55233",
                        "filesize": 67773,
                        "hash_type": "MD5",
                        "fileid": 55233,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:47:22",
                        "hash": "1dc6dd1a501e1d883c1d1a96dc06f44e",
                        "filename": "lightbox.jpg"
                    }
                ],
                "docid": 12935,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12935",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_lightbox",
                "placement": 15,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "preview.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/ispreviewThumbnailVersionOf",
                        "uri": "/id/document/1237"
                    }
                ],
                "pos": 16,
                "files": [
                    {
                        "objectid": 12936,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55234",
                        "filesize": 30156,
                        "hash_type": "MD5",
                        "fileid": 55234,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:47:23",
                        "hash": "3e12b214edbe23a33980ec196adf4d01",
                        "filename": "preview.jpg"
                    }
                ],
                "docid": 12936,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12936",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_preview",
                "placement": 16,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "medium.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/ismediumThumbnailVersionOf",
                        "uri": "/id/document/1237"
                    }
                ],
                "pos": 17,
                "files": [
                    {
                        "objectid": 12937,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55235",
                        "filesize": 9020,
                        "hash_type": "MD5",
                        "fileid": 55235,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:47:25",
                        "hash": "2508d9a9daef1ff93b631afb25a59e86",
                        "filename": "medium.jpg"
                    }
                ],
                "docid": 12937,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12937",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_medium",
                "placement": 17,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            },
            {
                "main": "small.jpg",
                "relation": [
                    {
                        "type": "http://eprints.org/relation/isVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/isVolatileVersionOf",
                        "uri": "/id/document/1237"
                    },
                    {
                        "type": "http://eprints.org/relation/issmallThumbnailVersionOf",
                        "uri": "/id/document/1237"
                    }
                ],
                "pos": 18,
                "files": [
                    {
                        "objectid": 12938,
                        "uri": "https://cbdu.ijp.pan.pl/id/file/55236",
                        "filesize": 2128,
                        "hash_type": "MD5",
                        "fileid": 55236,
                        "datasetid": "document",
                        "mime_type": "image/png",
                        "mtime": "2020-06-18 08:47:27",
                        "hash": "93d2e77aee526ecaa1831b65c1cfcdc7",
                        "filename": "small.jpg"
                    }
                ],
                "docid": 12938,
                "uri": "https://cbdu.ijp.pan.pl/id/document/12938",
                "formatdesc": "Thumbnails conversion from application/pdf to thumbnail_small",
                "placement": 18,
                "rev_number": 2,
                "security": "public",
                "eprintid": 4350,
                "mime_type": "image/png",
                "format": "other",
                "language": "pl"
            }
        ],
        "uri": "https://cbdu.ijp.pan.pl/id/eprint/4350",
        "microfilms": "BN Mf. 37926",
        "sheet_signing": "Sygn. A-D^4^",
        "rev_number": 63,
        "dictionary": [
            {
                "explanation": "przekupienie; naj\u0119cie kogo przeciw komu",
                "entry": "przenaj\u0119cie"
            },
            {
                "explanation": "car",
                "entry": "czar"
            },
            {
                "explanation": "szyk wojskowy",
                "entry": "ordynek"
            },
            {
                "explanation": "sprz\u0119t",
                "entry": "aparat"
            },
            {
                "explanation": "gruby; g\u0119sty, ci\u0119\u017cki",
                "entry": "mi\u0105\u017cszy"
            },
            {
                "explanation": "p\u00f3\u0142dzia\u0142ko, tj. ma\u0142e dzia\u0142o, ma\u0142a armata",
                "entry": "pu\u0142dzia\u0142ko"
            },
            {
                "explanation": "ci\u0119\u017cka strzelba zaopatrzona w hak do opierania jej w czasie strzelania",
                "entry": "hakownica"
            },
            {
                "explanation": "bro\u0144 sk\u0142adaj\u0105ca si\u0119 z osadzonych na jednym \u0142o\u017cysku rur muszkietowych, strzelaj\u0105cych jednocze\u015bnie; \u015bmigownica",
                "entry": "organki"
            },
            {
                "explanation": "bro\u0144 palna r\u0119czna albo osadzona na lawecie",
                "entry": "harkabuz"
            },
            {
                "explanation": "strzelba o bardzo d\u0142ugiej lufie i kr\u00f3tkiej, zakrzywionej kolbie, u\u017cywana przez janczar\u00f3w",
                "entry": "janczarka"
            },
            {
                "explanation": "rodzaj broni szturmowej, d\u0142ugie drzewce zako\u0144czone metalowym grotem, lanca",
                "entry": "kopija"
            },
            {
                "explanation": "inny",
                "entry": "inszy"
            },
            {
                "explanation": "\u017co\u0142nierz piechoty tureckiej utworzonej z wzi\u0119tych do niewoli chrze\u015bcijan, wychowanych na Turk\u00f3w",
                "entry": "janczar"
            },
            {
                "explanation": "p\u0142aszczyk, wierzchnia szata, noszona na zbroi, tu prawdopodobnie wykorzystana jako przykrycie, narzuta ",
                "entry": "welenc"
            },
            {
                "explanation": "rodzaj obicia; przykrycie",
                "entry": "szpaler"
            },
            {
                "explanation": "zbiorowo: m\u0119\u017cczy\u017ani, tu: \u017co\u0142nierze",
                "entry": "ch\u0142opie"
            },
            {
                "explanation": "latarnia",
                "entry": "laternia"
            },
            {
                "explanation": "z broni\u0105; b\u0119d\u0105c uzbrojonym",
                "entry": "armatno"
            },
            {
                "explanation": "m\u00f3wi\u0107, twierdzi\u0107 k\u0142amliwie",
                "entry": "udawa\u0107"
            },
            {
                "explanation": "kierownictwo, w\u0142adza",
                "entry": "dyrekcyja"
            },
            {
                "explanation": "ko\u0144 zaprz\u0119gni\u0119ty do podwody, tj. wozu ",
                "entry": "ko\u0144 podwodny"
            },
            {
                "explanation": "typ okr\u0119tu wojennego poruszanego za pomoc\u0105 wiose\u0142",
                "entry": "galera"
            },
            {
                "explanation": "rybak",
                "entry": "rybitw"
            },
            {
                "explanation": "\u017co\u0142nierz pochodzenia ch\u0142opskiego",
                "entry": "ch\u0142ope\u015blaus"
            },
            {
                "explanation": "\u017co\u0142nierz walcz\u0105cy kopi\u0105",
                "entry": "kopijnik"
            },
            {
                "explanation": "puszkarz, tj. kanonier, artylerzysta",
                "entry": "paszkarz"
            },
            {
                "explanation": "stary, do\u015bwiadczony \u017co\u0142nierz",
                "entry": "katan"
            },
            {
                "explanation": "rodzaj lekkiego powozu, bryczka",
                "entry": "kolasa"
            },
            {
                "explanation": "przednia cz\u0119\u015b\u0107 siod\u0142a",
                "entry": "\u0142\u0119k"
            },
            {
                "explanation": "obok",
                "entry": "mimo"
            },
            {
                "explanation": "bardzo du\u017ca liczba",
                "entry": "sroga rzecz"
            },
            {
                "explanation": "mo\u017ce szpahi(e)r, tj. \u017co\u0142nierz jazdy tureckiej",
                "entry": "spaj(a)"
            },
            {
                "explanation": "rz\u0105dca prowincji",
                "entry": "s\u0119dziak"
            },
            {
                "explanation": "tu przen.: co\u015b szkodliwego, zab\u00f3jczego jak chwast",
                "entry": "k\u0105kol "
            },
            {
                "explanation": "bisurma\u0144ski, tj. turecki",
                "entry": "bissurma\u0144ski"
            },
            {
                "explanation": "zajmuj\u0105cy du\u017ce terytorium",
                "entry": "szeroko nasiad\u0142y"
            },
            {
                "explanation": "defilada, parada wojskowa",
                "entry": "popis"
            },
            {
                "explanation": "rozwa\u017canie",
                "entry": "ponderacyja"
            },
            {
                "explanation": "miejsce postoju wojska, le\u017ce wojskowe",
                "entry": "stanowisko"
            },
            {
                "explanation": "obiecywa\u0107 sobie; spodziewa\u0107 si\u0119",
                "entry": "tuszy\u0107"
            },
            {
                "explanation": "tu, tutaj",
                "entry": "sam"
            },
            {
                "explanation": "kara \u015bmierci",
                "entry": "gard\u0142o"
            },
            {
                "explanation": "podejmowa\u0107 bitw\u0119, walk\u0119",
                "entry": "w pole stawia\u0107 (si\u0119)"
            },
            {
                "explanation": "dowiadywa\u0107 si\u0119, robi\u0107 wywiad",
                "entry": "bada\u0107 si\u0119"
            },
            {
                "explanation": "werwa, zapa\u0142, ch\u0119\u0107 (tu: do walki)",
                "entry": "animusz"
            },
            {
                "explanation": "stacza\u0107 bitw\u0119",
                "entry": "bitw\u0119 zwodzi\u0107"
            },
            {
                "explanation": "dru\u017cyna wojskowa dowodzona przez towarzysza, orszak",
                "entry": "poczet"
            },
            {
                "explanation": "pa\u0142aj\u0105cy gniewem, \u017c\u0105dz\u0105 pokonania, pobicia kogo\u015b",
                "entry": "zajuszony"
            },
            {
                "explanation": "zbiorowo: bro\u0144, uzbrojenie",
                "entry": "armata"
            },
            {
                "explanation": "\u017cywno\u015b\u0107; zapas \u017cywno\u015bci",
                "entry": "prowiant"
            },
            {
                "explanation": "pisemne rozporz\u0105dzenie w\u0142adzy, nakaz",
                "entry": "mandat"
            },
            {
                "explanation": "pod gro\u017ab\u0105 kary \u015bmierci",
                "entry": "pod gard\u0142em"
            },
            {
                "explanation": "poselstwo",
                "entry": "legacyja "
            },
            {
                "explanation": "przestronny",
                "entry": "przestrony"
            },
            {
                "explanation": "albo",
                "entry": "abo"
            },
            {
                "explanation": "zatroskany, zmartwiony",
                "entry": "zturbowany"
            },
            {
                "explanation": "zaj\u0119cie",
                "entry": "zabawka"
            },
            {
                "explanation": "stan\u0105\u0107 komu na drodze, nie dopu\u015bci\u0107 do dalszego posuwania si\u0119",
                "entry": "drog\u0119 komu zajecha\u0107"
            },
            {
                "explanation": "udzieli\u0107 czego, da\u0107 co; odst\u0105pi\u0107 co",
                "entry": "pozwoli\u0107"
            },
            {
                "explanation": "wg muzu\u0142manina ka\u017cdy innowierca, tu: katolik",
                "entry": "gaur"
            },
            {
                "explanation": "wrzawa, zamieszanie, zam\u0119t",
                "entry": "tumult"
            },
            {
                "explanation": "pokaz",
                "entry": "monstra"
            },
            {
                "explanation": "wydarzenie",
                "entry": "okazyja"
            },
            {
                "explanation": "szersze\u0144, tu ekspresywnie: Turek, muzu\u0142manin",
                "entry": "siersze\u0144"
            },
            {
                "explanation": "opr\u00f3cz",
                "entry": "okrom"
            },
            {
                "explanation": "formacja taktyczna, poczet \u017co\u0142nierzy; hufiec",
                "entry": "ufiec"
            },
            {
                "explanation": "przen. porz\u0105dek, rygor",
                "entry": "kluba"
            },
            {
                "explanation": "m\u0119\u017cczyzna; \u017co\u0142nierz",
                "entry": "m\u0105\u017c"
            },
            {
                "explanation": "odwa\u017cny, m\u0119\u017cny",
                "entry": "serdeczny"
            },
            {
                "explanation": "zwierz\u0119",
                "entry": "bestyja"
            },
            {
                "explanation": "spos\u00f3b post\u0119powania",
                "entry": "proceder"
            },
            {
                "explanation": "jezdny, konny",
                "entry": "komunny"
            },
            {
                "explanation": "o drodze: czyni\u0107 woln\u0105, przejezdn\u0105, usuwa\u0107 z niej przeszkody",
                "entry": "uprzestrzenia\u0107"
            },
            {
                "explanation": "lekka, krzywa szabla",
                "entry": "karabelka"
            },
            {
                "explanation": null,
                "entry": "jandziura"
            },
            {
                "explanation": "lampart, pantera; tu: strzelec, osadzony na galerze, pos\u0142uguj\u0105cy si\u0119 strzelb\u0105 janczark\u0105, ubrany w str\u00f3j wykonany ze sk\u00f3ry lamparciej",
                "entry": "lewart"
            },
            {
                "explanation": "\u017co\u0142nierz doborowych oddzia\u0142\u00f3w wojska, tu: osadzony na galerze",
                "entry": "gwardyjan"
            },
            {
                "explanation": "laskami ... maj\u0105cymi ostre okucia na ko\u0144cach",
                "entry": "z \u0142askami ... ostro zakowanemi"
            },
            {
                "explanation": "do przebicia ch\u0142opa",
                "entry": "do przebycia ch\u0142opa"
            },
            {
                "explanation": "\u017co\u0142nierz walcz\u0105cy spis\u0105, tj. broni\u0105 drzewcow\u0105 u\u017cywan\u0105 w walce konnej i pieszej, inaczej dzid\u0105, kopi\u0105, w\u0142\u00f3czni\u0105",
                "entry": "spi\u015bnik"
            },
            {
                "explanation": null,
                "entry": "puppa"
            },
            {
                "explanation": null,
                "entry": "sentyna"
            },
            {
                "explanation": null,
                "entry": "rejza"
            },
            {
                "explanation": "spisa, tj. bro\u0144 drzewcowa u\u017cywana w walce konnej i pieszej, inaczej dzida, kopia, w\u0142\u00f3cznia",
                "entry": "spisza"
            },
            {
                "explanation": "czausz, tj. goniec, pos\u0142aniec turecki",
                "entry": "czaus"
            },
            {
                "explanation": "pancerz",
                "entry": "pancer"
            },
            {
                "explanation": "konie",
                "entry": "kenie"
            },
            {
                "explanation": null,
                "entry": "cie\u015bniejer"
            },
            {
                "explanation": null,
                "entry": "sejnien"
            },
            {
                "explanation": "prawdziwie doborowy, dobrany",
                "entry": "prawie przybrany"
            },
            {
                "explanation": "turban turecki",
                "entry": "zaw\u00f3j dywa\u0144ski"
            },
            {
                "explanation": null,
                "entry": "tapczylar"
            },
            {
                "explanation": "rodzaj \u017co\u0142nierza pieszego, strzelca pos\u0142uguj\u0105cego si\u0119 strzelb\u0105 janczark\u0105",
                "entry": "asabistan"
            },
            {
                "explanation": "uprz\u0105\u017c wierzchowca",
                "entry": "rz\u0105d"
            },
            {
                "explanation": "czaprak, tj. przykrycie konia pod siod\u0142o; d\u0142uga ozdobna kapa okrywaj\u0105ca konia, u\u017cywana przez ci\u0119\u017ck\u0105 jazd\u0119",
                "entry": "czaprag"
            },
            {
                "explanation": "at\u0142as",
                "entry": "hat\u0142as"
            },
            {
                "explanation": null,
                "entry": "martuzanin, martazanin"
            },
            {
                "explanation": "przykrycie, pokrowiec, narzuta",
                "entry": "deka"
            },
            {
                "explanation": null,
                "entry": "odrzemienia"
            },
            {
                "explanation": "ka\u0142kan, tj. okr\u0105g\u0142a tarcza z pr\u0119t\u00f3w oplecionych barwnym jedwabiem",
                "entry": "ka\u0142chan"
            },
            {
                "explanation": "\u017co\u0142nierz pos\u0142uguj\u0105cy si\u0119 kopi\u0105",
                "entry": "kajmar"
            },
            {
                "explanation": "d\u0142uga czapka futrzana",
                "entry": "kuczma"
            },
            {
                "explanation": "wykonany z futra kuny",
                "entry": "kuni"
            },
            {
                "explanation": "pancerz os\u0142aniaj\u0105cy pier\u015b",
                "entry": "bechter"
            },
            {
                "explanation": "w strojach wykonanych ze sk\u00f3r lampart\u00f3w i tygrys\u00f3w",
                "entry": "w lampartach i tygrysach"
            },
            {
                "explanation": "szturmak, tj. r\u0119czna bro\u0144 palna, strzelba z luf\u0105 rozszerzon\u0105 u wylotu ",
                "entry": "sturmak"
            },
            {
                "explanation": "husarz, tj. \u017co\u0142nierz ci\u0119\u017ckiej jazdy uzbrojony w kopi\u0119, nosz\u0105cy zbroj\u0119 i skrzyd\u0142a",
                "entry": "usarz"
            },
            {
                "explanation": "rodzaj ochronnego p\u00f3\u0142r\u0119kawa si\u0119gaj\u0105cego od napi\u0119stka za \u0142okie\u0107, wk\u0142adanego na r\u0119kaw",
                "entry": "zar\u0119kawek"
            },
            {
                "explanation": "tu: wojskowy b\u0142azen, sztukmistrz",
                "entry": "figlarz"
            },
            {
                "explanation": "zakuty",
                "entry": "zakowany"
            },
            {
                "explanation": "sztuki",
                "entry": "kunszty"
            },
            {
                "explanation": "haftowany",
                "entry": "aftowany"
            },
            {
                "explanation": "ros\u0142y w\u00f3\u0142 ",
                "entry": "czaban"
            },
            {
                "explanation": "tu: dr\u0105\u017cek \u017celazny",
                "entry": "ro\u017cen"
            },
            {
                "explanation": "sadzony, wysadzany, inkrustowany",
                "entry": "rysowany"
            },
            {
                "explanation": "halabarda",
                "entry": "alabarta"
            },
            {
                "explanation": "kirys, tj. zbroja; tu: ochronna pow\u0142oka na konia",
                "entry": "kirysz"
            },
            {
                "explanation": "na w\u00f3zkach dwuko\u0142owych",
                "entry": "na w\u00f3zkach dwuko\u0142"
            },
            {
                "explanation": "lichy, marny",
                "entry": "pod\u0142y"
            },
            {
                "explanation": "cz\u0119\u015b\u0107 szyszaka, zas\u0142aniaj\u0105ca twarz",
                "entry": "misiurka"
            },
            {
                "explanation": "bogato, wystawnie",
                "entry": "szumno"
            },
            {
                "explanation": "czo\u0142dar, tj. czaprak, przykrycie konia pod siod\u0142o; d\u0142uga ozdobna kapa okrywaj\u0105ca konia, u\u017cywana przez ci\u0119\u017ck\u0105 jazd\u0119",
                "entry": "szo\u0142dar"
            },
            {
                "explanation": "he\u0142m tzw. burgundzki, zaopatrzony w grzebie\u0144, nakarczek, policzki oraz daszek os\u0142aniaj\u0105cy oczy",
                "entry": "szturmak"
            },
            {
                "explanation": "wierzchni ubi\u00f3r m\u0119ski, podbity futrem, d\u0142ugi, z szerokimi niezszytymi r\u0119kawami i z du\u017cym ko\u0142nierzem",
                "entry": "delija"
            },
            {
                "explanation": "w\u0105ski pasek materii do obszywania brzeg\u00f3w ubrania",
                "entry": "listwa"
            },
            {
                "explanation": "w strojach wykonanych ze sk\u00f3ry wilka",
                "entry": "w wilkach"
            },
            {
                "explanation": "tr\u0105bi\u0105c w rogi",
                "entry": "tr\u0105bi\u0105c ro\u017cnie"
            },
            {
                "explanation": null,
                "entry": "dramogty"
            },
            {
                "explanation": "niewielki",
                "entry": "mierny"
            },
            {
                "explanation": "prawdopodobnie: bostandziej, bostand\u017cy, tj. cz\u0142onek pomocniczej s\u0142u\u017cby pa\u0142acowej",
                "entry": "bosztardziej"
            },
            {
                "explanation": "w\u00f3z, kt\u00f3rym przewo\u017cono kosztowno\u015bci",
                "entry": "skarbny w\u00f3z"
            },
            {
                "explanation": "kapedzi(j), tj. od\u017awierny, \u017co\u0142nierz pe\u0142ni\u0105cy stra\u017c u bram pa\u0142acu su\u0142ta\u0144skiego konnego",
                "entry": "kapudziej"
            },
            {
                "explanation": "ciorbudzi(j), tj. oficer janczarski",
                "entry": "czerbadziej"
            },
            {
                "explanation": "dow\u00f3dca janczar\u00f3w",
                "entry": "janczaraga"
            },
            {
                "explanation": null,
                "entry": "prostardziej"
            },
            {
                "explanation": "ciorbudzi(j), tj. oficer janczarski",
                "entry": "czorburdziej"
            },
            {
                "explanation": "sk\u00f3rzany worek, sak podr\u00f3\u017cny, w kt\u00f3ry \u0142aduje si\u0119 baga\u017ce, przewo\u017cone zwykle na grzbietach zwierz\u0105t; baga\u017c, tob\u00f3\u0142",
                "entry": "juk"
            },
            {
                "explanation": "sta\u0107 si\u0119 chromym, tj. utykaj\u0105cym na nog\u0119, kulawym",
                "entry": "ochrama\u0107"
            },
            {
                "explanation": "mierz\u0105cy s\u0105\u017ce\u0144, tj. ok. 190 cm albo bardzo du\u017cy, pot\u0119\u017cnych rozmiar\u00f3w",
                "entry": "s\u0105\u017cenisty"
            },
            {
                "explanation": "to\u0142umbas, tj. turecki b\u0119ben wojskowy, zwykle du\u017cy, czasem te\u017c zaopatrzony w dzwonki, taraban",
                "entry": "tolumbas"
            },
            {
                "explanation": "chodzia, tj. nauczyciel; duchowny; tytu\u0142 grzeczno\u015bciowy, nadawany ze wzgl\u0119du na wiek, uczono\u015b\u0107 lub stan duchowny",
                "entry": "chodziej"
            },
            {
                "explanation": "tytu\u0142 arystokratyczny, ksi\u0105\u017c\u0119",
                "entry": "emir"
            },
            {
                "explanation": "ludzie ubrani w lekkie, przewiewne, noszone w lecie stroje",
                "entry": "ludzie letni"
            },
            {
                "explanation": null,
                "entry": "lairajowy"
            },
            {
                "explanation": "kady(j), tj. s\u0119dzia muzu\u0142ma\u0144skiego prawa religijnego",
                "entry": "kadyj"
            },
            {
                "explanation": "kr\u00f3tki czaprak",
                "entry": "mituk"
            },
            {
                "explanation": "ozdoba z nici, jedwabiu, sznurka itp. w kszta\u0142cie p\u0119dzla",
                "entry": "kutas"
            },
            {
                "explanation": "\u017cak, tj. ubogi student ",
                "entry": "zak"
            },
            {
                "explanation": "w bogatych szatach",
                "entry": "szatno"
            },
            {
                "explanation": "wysoka czapka, cz\u0119sto ozdobna, obszyta futrem",
                "entry": "ko\u0142pak"
            },
            {
                "explanation": "my\u015bliwy",
                "entry": "my\u015bliwiec"
            },
            {
                "explanation": "przykrycie, pokrowiec, kilim, dera, tu: przytrzymuj\u0105ce i chroni\u0105ce drogie czapraki",
                "entry": "deka"
            },
            {
                "explanation": "rodzaj \u017co\u0142nierza pieszego",
                "entry": "szalak"
            },
            {
                "explanation": "kurtka noszona przez \u017co\u0142nierzy",
                "entry": "katanka"
            },
            {
                "explanation": "\u0142uk",
                "entry": "tuk"
            },
            {
                "explanation": "Mahometowy",
                "entry": "Machomet\u00f3w"
            },
            {
                "explanation": "obszerny p\u0142aszcz m\u0119ski, si\u0119gaj\u0105cy \u0142ydek, wci\u0119ty w pasie, z przodu szamerowany",
                "entry": "ferezyja"
            },
            {
                "explanation": "zapinka, spinka, klamra",
                "entry": "zapona"
            },
            {
                "explanation": "o ma\u015bci konia: kasztanowaty, jasnogniady",
                "entry": "cisawy"
            },
            {
                "explanation": "na czole",
                "entry": "na czele"
            },
            {
                "explanation": "fantazyjny, wymy\u015blny no\u017cyk przypominaj\u0105cy kszta\u0142tem bia\u0142ozora, tj. ptaka drapie\u017cnego z rodziny soko\u0142\u00f3w, u\u017cywanego kiedy\u015b jako ptak \u0142owczy",
                "entry": "bia\u0142ozorzy no\u017cyk"
            },
            {
                "explanation": "doborowy, dobrany",
                "entry": "przebrany"
            },
            {
                "explanation": "kolorowy, barwny",
                "entry": "barwiany"
            },
            {
                "explanation": "syn hospodara",
                "entry": "hospodarczyk"
            },
            {
                "explanation": "eunuch, tj. rzezaniec pilnuj\u0105cy haremu",
                "entry": "ewnuch"
            },
            {
                "explanation": "cz\u0142onek orkiestry wojskowej graj\u0105cy na b\u0119bnie",
                "entry": "dobosz"
            },
            {
                "explanation": "cz\u0142onek orkiestry wojskowej graj\u0105cy na surmie",
                "entry": "szurmacz"
            },
            {
                "explanation": "cz\u0142onek orkiestry wojskowej graj\u0105cy na piszcza\u0142ce",
                "entry": "piszczek"
            },
            {
                "explanation": "zapewne spah, spahis lub szpahi(e)r, tj. \u017co\u0142nierz jazdy tureckiej, tu prawdopodobnie: wyborowy \u017co\u0142nierz konny, maj\u0105cy tytu\u0142 arystokratyczny",
                "entry": "spaj"
            },
            {
                "explanation": "w du\u017cej liczbie m\u0119\u017cczyzn, tu: \u017co\u0142nierzy",
                "entry": "ch\u0142opno"
            },
            {
                "explanation": "bia\u0142oz\u00f3r, tj. ptak drapie\u017cny z rodziny soko\u0142\u00f3w, u\u017cywany kiedy\u015b jako ptak \u0142owczy",
                "entry": "bia\u0142o\u017c\u00f3r"
            },
            {
                "explanation": "przystan\u0119li ko\u0142o nas",
                "entry": "postali do nas"
            },
            {
                "explanation": "mo\u017ce, a nu\u017c",
                "entry": "aza"
            },
            {
                "explanation": "o koniu: maj\u0105cy czarn\u0105 ma\u015b\u0107, kary",
                "entry": "wrony"
            },
            {
                "explanation": "droga tkanina przetykana z\u0142otymi ni\u0107mi",
                "entry": "z\u0142otog\u0142\u00f3w"
            },
            {
                "explanation": "najlepszej jako\u015bci",
                "entry": "przedni"
            },
            {
                "explanation": "fr\u0119dzla, cz\u0119\u015bciej w lm: g\u0119sto i lu\u017ano zwisaj\u0105ce nitki lub sznureczki, \u0142\u0105czone po kilka, jako ozdoba, zako\u0144czenie brzeg\u00f3w serwet, chustek itp.",
                "entry": "frandzla"
            },
            {
                "explanation": "miara d\u0142ugo\u015bci, ok. 190 cm",
                "entry": "s\u0105\u017ce\u0144"
            },
            {
                "explanation": "trzcinowy",
                "entry": "trciniany"
            },
            {
                "explanation": "zamiast",
                "entry": "miasto"
            },
            {
                "explanation": "sprz\u0105czka",
                "entry": "prz\u0119cka"
            },
            {
                "explanation": "efektowny, robi\u0105cy wra\u017cenie",
                "entry": "szumny"
            },
            {
                "explanation": "prawdziwie",
                "entry": "prawie"
            },
            {
                "explanation": "pi\u0119kny ko\u0144 wierzchowy lub cugowy rasy w\u0142oskiej, hiszpa\u0144skiej lub tureckiej",
                "entry": "dzianet"
            },
            {
                "explanation": "droga tkanina przetykana srebrnymi ni\u0107mi",
                "entry": "srebrog\u0142\u00f3w"
            },
            {
                "explanation": "dzielny",
                "entry": "grzeczny"
            },
            {
                "explanation": "Arab",
                "entry": "Harab"
            },
            {
                "explanation": "ten, kto zajmuje si\u0119 goleniem, strzy\u017ceniem i wykonywaniem prostych zabieg\u00f3w medycznych",
                "entry": "balwierz"
            },
            {
                "explanation": "rodzaj wyci\u0105gu z zi\u00f3\u0142 o dzia\u0142aniu odurzaj\u0105cym",
                "entry": "mas\u0142ok"
            },
            {
                "explanation": "dr\u0105g \u017celazny lub drewniany okuty \u017celazem, u\u017cywany do wbijania w twardy grunt",
                "entry": "kostur"
            },
            {
                "explanation": "rodzaj jednoko\u0142owego r\u0119cznego w\u00f3zka do przewo\u017cenia ci\u0119\u017car\u00f3w",
                "entry": "taki"
            },
            {
                "explanation": "wytrwa\u0142y",
                "entry": "trwa\u0142y"
            },
            {
                "explanation": "sprawy rycerskie; rzemios\u0142o rycerskie",
                "entry": "dzie\u0142a rycerskie"
            },
            {
                "explanation": "Orda tatarska",
                "entry": "Horda tatarska"
            },
            {
                "explanation": "by\u0107 na kogo obra\u017conym, zagniewanym",
                "entry": "zwa\u015bni\u0107 si\u0119 na kogo"
            },
            {
                "explanation": "nawi\u0105za\u0107 kontakt z kim",
                "entry": "obwo\u0142a\u0107"
            },
            {
                "explanation": "wyprawi\u0107 poselstwo",
                "entry": "obes\u0142a\u0107"
            },
            {
                "explanation": "sprawi\u0107 komu k\u0142opot, spowodowa\u0107 u kogo zamieszanie",
                "entry": "zturbowa\u0107 kogo"
            },
            {
                "explanation": "przygotowa\u0107",
                "entry": "nagotowa\u0107 "
            },
            {
                "explanation": "luteranie",
                "entry": "Lutry"
            },
            {
                "explanation": "utrzymywa\u0107 z kim dobre stosunki",
                "entry": "chowa\u0107 si\u0119 z kim dobrze"
            },
            {
                "explanation": "nic z tego nie b\u0119dziemy mieli",
                "entry": "nam piskorz b\u0119dzie"
            },
            {
                "explanation": "robi\u0107 dla kogo to, co nale\u017cy",
                "entry": "komu uczciwo\u015b\u0107 wyrz\u0105dza\u0106"
            },
            {
                "explanation": "n\u0119ka\u0107, dokucza\u0107, m\u0119czy\u0107; bi\u0107",
                "entry": "kuk\u0142a\u0107"
            },
            {
                "explanation": "wybada\u0107",
                "entry": "zrozumie\u0107"
            },
            {
                "explanation": "zawrze\u0107 z kim przymierze",
                "entry": "lig\u0119 z kim uczyni\u0107"
            },
            {
                "explanation": "trudno\u015b\u0107",
                "entry": "wstr\u0119t"
            },
            {
                "explanation": "niema\u0142y; istotny, nie mniej wa\u017cny",
                "entry": "niepod\u0142y"
            },
            {
                "explanation": "katolik",
                "entry": "papie\u017cnik"
            },
            {
                "explanation": "powsta\u0107 przeciw komu",
                "entry": "oburzy\u0107 si\u0119 na kogo"
            },
            {
                "explanation": "pokonaliby nas ca\u0142kowicie, unicestwiliby nas (tak, \u017ce nikt by o nas nie pami\u0119ta\u0142)",
                "entry": "pami\u0119ci [by po nas] nie zostawili"
            },
            {
                "explanation": "mimo, tj. obok, w pobli\u017cu",
                "entry": "imo"
            },
            {
                "explanation": "przodek; poprzednik",
                "entry": "antecessor"
            },
            {
                "explanation": "oddzia\u0142 wojska zapuszczaj\u0105cy si\u0119 w kraj nieprzyjaciela",
                "entry": "zagon"
            },
            {
                "explanation": "ob\u00f3z wojskowy tatarski lub kozacki; oddzia\u0142 wojska tatarskiego lub kozackiego",
                "entry": "kosz"
            },
            {
                "explanation": "smutek, przygn\u0119bienie, pos\u0119pny nastr\u00f3j",
                "entry": "melankolija"
            },
            {
                "explanation": "doprowadzi\u0107 co do punktu, z kt\u00f3rego nie ma odwrotu",
                "entry": "zawie\u015b\u0107 si\u0119"
            },
            {
                "explanation": "nie wolno nam",
                "entry": "niel\u017ca nam"
            },
            {
                "explanation": "stacza\u0107 z kim bitwy, potyczki",
                "entry": "z kim si\u0119 potyka\u0107"
            },
            {
                "explanation": "bitwa, wojna",
                "entry": "potrzeba"
            },
            {
                "explanation": "podst\u0119pny, sprytny, wymy\u015blny",
                "entry": "sztuczny"
            },
            {
                "explanation": "wynagrodzenie, zap\u0142ata",
                "entry": "kontentacyja"
            },
            {
                "explanation": "gdy jest za p\u00f3\u017ano, tu: po podj\u0119ciu decyzji, z kt\u00f3rych nie mo\u017cna si\u0119 wycofa\u0107",
                "entry": "po zawodzie"
            },
            {
                "explanation": "spr\u00f3bowa\u0107 szcz\u0119\u015bcia",
                "entry": "pokusi\u0107 szcz\u0119\u015bcia"
            },
            {
                "explanation": "pogl\u0105d, zdanie, uwaga",
                "entry": "konsyderacyja"
            },
            {
                "explanation": "rozwa\u017canie; argument",
                "entry": "ponderacyja"
            },
            {
                "explanation": "by\u0107 z kim w \u015bcis\u0142ym zwi\u0105zku, sojuszu",
                "entry": "z kim za jedno tchn\u0105\u0107"
            },
            {
                "explanation": "intensywny, uporczywy, nies\u0142abn\u0105cy",
                "entry": "zawzi\u0119ty"
            },
            {
                "explanation": "mieszkaniec nieba, anio\u0142, \u015bwi\u0119ty",
                "entry": "obywatel niebieski"
            },
            {
                "explanation": "zabiega\u0107 o co",
                "entry": "upatrywa\u0107 czego"
            },
            {
                "explanation": "miejsce obwarowane; zamek, baszta, warownia, szaniec",
                "entry": "ostr\u00f3g"
            },
            {
                "explanation": "zbrojny, uzbrojony",
                "entry": "armatny"
            },
            {
                "explanation": "przygotowywa\u0107",
                "entry": "gotowa\u0107"
            },
            {
                "explanation": "Wielkopolanie i Ma\u0142opolanie",
                "entry": "Wielcy y Mali Polacy"
            },
            {
                "explanation": "\u017cyczy\u0107",
                "entry": "winszowa\u0107"
            },
            {
                "explanation": "tu: nie pozwoli\u0107 si\u0119 komu podbi\u0107",
                "entry": "komu si\u0119 odejmowa\u0107"
            },
            {
                "explanation": "danina, haracz",
                "entry": "trybut"
            },
            {
                "explanation": "zdrobniale od ostr\u00f3g, tj. miejsce obwarowane; zamek, baszta, warownia, szaniec",
                "entry": "ostro\u017cek"
            },
            {
                "explanation": "wstawiennictwo, or\u0119downictwo",
                "entry": "przyczyna"
            },
            {
                "explanation": "obronnie, warownie",
                "entry": "ostro\u017cno"
            },
            {
                "explanation": "wycelowany",
                "entry": "narychtowany"
            },
            {
                "explanation": "tyle, ile trzeba",
                "entry": "z potrzeb\u0119"
            },
            {
                "explanation": "bezpiecznie, tj. bez obawy, \u015bmia\u0142o",
                "entry": "be\u015bpiecznie"
            },
            {
                "explanation": "ni\u017c",
                "entry": "ni\u017celi"
            },
            {
                "explanation": "musztra, tj. parada, defilada wojskowa, \u0107wiczenia wojskowe",
                "entry": "munstra"
            },
            {
                "explanation": "cz\u0142onek orkiestry wojskowej graj\u0105cy na b\u0119bnie, dobosz",
                "entry": "b\u0119benista"
            }
        ],
        "copies": [
            "BN XVII. 3. 5789",
            "KUL XVII, 1077",
            "PAN K\u00f3rn. 12632"
        ],
        "type": "book",
        "language": [
            "pl"
        ],
        "full_title": "[Tytu\u0142 w ramce z ozdobnik\u00f3w drukarskich, ant.:] WYPRAWA || [frakt.:] Y || [ant.:] WYIAZD || Woysk\u00e1, z Konst\u00e1ntynopola, || Wielkiego y pot\u0119\u017cnego Monarchy || SV\u0141TANA AMVRATA || Ces\u00e1rz\u00e1 Tureckiego ter\u00e1\u017anieyszego. || [szwab.:] N\u00e1 Woyn\u0119 do Korony Polskiey. || [kurs.:] A to z namowy, r\u00e1dy, y przen\u00e1i\u0119\u0107ia, t\u00e1k Luterskiego, i\u00e1ko y || Cz\u00e1r\u00e1 Wielkiego Moskiewskiego, y in\u00dfych || K\u00e1tholickich Nieprzyia\u0107io\u0142. || [szwab.:] Roku Pa\u0144skiego 1634. || [listewka] ||",
        "date_of_pub": "[po 13 IV] 1634",
        "title": "Wyprawa i wyjazd su\u0142tana Amurata, cesarza tureckiego, na wojn\u0119 do Korony Polskiej"
    }
]

export default cbduJsonSample